import { vnTemplate } from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate';
import { filterDropdown_template } from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template';
import { filterDate_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4core from "@amcharts/amcharts4/core";
import {amCharts_v4_date_basic_template} from "./amCharts_v4_date_basic_template";
import {amCharts_v4_category_donut_template} from "./amCharts_v4_category_donut_template";
import {presetFilter_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/presetFilter_template";
import {filterSingle_multiLevel_selector_template} from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingle_multiLevel_selector_template';
import {filterMultipleAutoComplete_template} from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterMultipleAutoComplete_template';
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { vnApp_sentinelbi } from '../vnApp_sentinelbi';

declare var ko: any;

export class liveDashboard_template extends vnTemplate {

    protected indicatorsChart: amCharts_v4_date_basic_template;
    protected pingDiffIndicatorsChart: amCharts_v4_date_basic_template;
    protected pingAvgLoadIndicatorsChart: amCharts_v4_date_basic_template;
    protected usViewsDonutChart: amCharts_v4_category_donut_template;
    protected androidViewsDonutChart: amCharts_v4_category_donut_template;
    protected brandFilter: filterSingle_multiLevel_selector_template;
    protected dateRangeFilter: filterDate_template;
    protected compRangeFilter: filterDate_template;
    protected viewModeFilter: filterDropdown_template;
    protected multiSegmentsFilter : multipleSelector_template;
    protected segmentsFilter : filterDropdown_template;
    protected presetFilter: presetFilter_template;
    protected reportStatusTooltip: infoButton_template;
    protected pingGraphTooltip: infoButton_template;
    protected sourcesTooltip: infoButton_template;
    protected devicesTooltip: infoButton_template;
    protected geoTooltip: infoButton_template;
    protected pingAvgLoadGraphTooltip: infoButton_template;
    protected comparisonFilter: filterSingle_multiLevel_selector_template;
    protected metricFilter: filterSingle_multiLevel_selector_template;
    protected intervalFilter: filterSingle_multiLevel_selector_template;
    protected deltaFilter: filterSingle_multiLevel_selector_template;
    protected pagination: pagination_template;
    protected annotationTooltip: infoButton_template;
    protected engagedPagesTooltip: infoButton_template;
    protected engagedBreakdownTooltips!: {[duration: string]: infoButton_template};
    protected avgViewDurationTooltip!: infoButton_template;
    protected relativePerformanceTooltip!: infoButton_template;
    protected timeOnPageTooltip!: infoButton_template;
    protected interactionRatioTooltip!: infoButton_template;

    readonly comparisonValues = [
        {"id": "lastWeek", "name": "Last Week"},
        {"id": "yesterday", "name": "Yesterday"},
    ];

    readonly metricValues = [
        {"id": "visits", "name": "Visits"},
        {"id": "views", "name": "Views"},
    ];

    readonly intervalValues = [
        {"id": "5", "name": "5 Minutes"},
        {"id": "10", "name": "10 Minutes"},
        {"id": "15", "name": "15 Minutes"},
        {"id": "20", "name": "20 Minutes"},
        {"id": "30", "name": "30 Minutes"},
    ];

    readonly deltaValuesExtended = [
        {"id": "segmentSystemAverage", "name": "Seg/System Avg"},
        {"id": "filterAverage", "name": "Filter Avg"},
        {"id": "off", "name": "Off"},
    ];

    readonly deltaValuesDefault = [
        {"id": "filterAverage", "name": "Filter Avg"},
        {"id": "off", "name": "Off"},
    ];

    /**
     * @inheritDoc
     */
    protected getTemplateHtml(): string{

        return `
            <div id="report-results">

                <div class="page-header">
                    <div class="button-default-group">
                        <button data-bind="click: toggleOpenMetrics" class="button-default mobile-filters icon i-select" type="button"></button>
                        <button class="button-default mobile-filters icon i-filters no-after filterToggle-btn" data-bind="event: {click: toggleOpenFilters}"></button>
                        <button class="button-default mobile-filters icon i-select no-after i-preferences" data-bind="event: { click: onSidebarToggle }" class="button-default no-text icon i-preferences preferences no-after" type="button" title="report preferences"></button>
                    </div>

                    <h2 class="title-page">Live Dashboard</h2>

                    <div data-bind="if: reportStatusData()" class="report-status">
                        <div class="button-default"
                            data-bind="css: {
                                'status-ok': reportStatusData().status === 'LIVE',
                                'status-delayed': reportStatusData().status === 'DELAYED',
                                'status-error': reportStatusData().status === 'ERRORS'
                            }">
                            <span data-bind="css: {
                                'icon i-live': reportStatusData().status === 'LIVE'
                            }"></span>

                            <div class="status" data-bind="text: reportStatusData().status"></div>

                            <div data-bind="if: reportStatusData().status === 'DELAYED' || reportStatusData().status === 'ERRORS'">
                                <div class="report-status-tooltip">
                                    <p style="text-transform: none;" data-bind="html: reportStatusData().message"></p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>


                <div class="w-justify block-filters side-block-filters" data-bind="css: isMetricsOpen() ? 'is-open' : '' "> <!-- is-open -->
                    <button data-bind="event: { click: onSidebarToggle }" class="button-default no-text icon i-preferences preferences no-after js-sidebar" type="button" title="report preferences">
                        <span class="hide-text">REPORT PREFERENCES</span>
                    </button>
                    <div class="w-right flex-all block-default">
                        <div class="w-justify full-width">
                            <div class="w-left">
                                <div class="sidebar-default-header">
                                    <span class="label-default sidebar-default-header icon i-select">Filters</span>
                                    <button data-bind="click: toggleOpenMetrics" type="button" class="btn-close-default icon i-close"><span></span></button>
                                </div>


                                <div class="w-brand-filter">
                                    ${this.brandFilter.getHtmlBuild()}
                                    <div class="w-btn">
                                        <button type="button" class="icon i-dropdown-simple-b" data-bind="click: onCycleBrand.bind(this, $data, true)"><span>Prev</span></button>
                                        <button type="button" class="icon i-dropdown-simple-b" data-bind="click: onCycleBrand.bind(this, $data, false)"><span>Next</span></button>
                                    </div>
                                </div>

                                <div>
                                    ${this.comparisonFilter.getHtmlBuild()}
                                </div>
                                <div>
                                    ${this.metricFilter.getHtmlBuild()}
                                </div>
                                <div>
                                    ${this.intervalFilter.getHtmlBuild()}
                                </div>

                                    <!-- ko foreach: dynamicFiltersGrouped -->

                                        <!-- ko foreach: Object.values(names) -->

                                            <!-- ko if: $parents[1].segmentsFilterException() && name === 'segment' -->

                                                <!-- ko foreach: filters -->
                                                    <div>
                                                        <!-- ko if: type === 'multiSelect' -->
                                                            <div data-bind="template: {name: 'multiSelector-template', data: filter.getTemplateViewModel()}" class="has-multi"></div>
                                                        <!-- /ko -->

                                                        <!-- ko if: type === 'autoCompleteMultiSelect' -->
                                                            <div data-bind="template: {name: 'filterMultipleAutoComplete-template', data: filter.getTemplateViewModel()}"></div>
                                                        <!-- /ko -->
                                                    </div>
                                                <!-- /ko -->
                                            <!-- /ko -->
                                            <!-- ko if: $parents[1].systemsFilterException() && name === 'system' -->

                                                <!-- ko foreach: filters -->
                                                    <div>
                                                        <!-- ko if: type === 'multiSelect' -->
                                                            <div data-bind="template: {name: 'multiSelector-template', data: filter.getTemplateViewModel()}" class="has-multi"></div>
                                                        <!-- /ko -->

                                                        <!-- ko if: type === 'autoCompleteMultiSelect' -->
                                                            <div data-bind="template: {name: 'filterMultipleAutoComplete-template', data: filter.getTemplateViewModel()}"></div>
                                                        <!-- /ko -->
                                                    </div>
                                                <!-- /ko -->
                                            <!-- /ko -->
                                        <!-- /ko -->
                                    <!-- /ko -->

                                <div class="separator"></div>
                                <button class="btn-filter-show icon i-filters no-after filterToggle-btn" data-bind="event: {click: toggleOpenFilters}">Filters</button>
                            </div>

                            <div class="w-right">
                                <!-- ko if: botToggleButtonException() -->
                                    <button class="btn-filter-show icon no-after filterToggle-btn" data-bind="text: isBotMode() ? 'Exclude Bots' : 'Include Bots', event: {click: toggleBotMode}"></button>
                                <!-- /ko -->
                                <div class="w-filter-preset hide-mobile" data-bind="visible: false, event: { mouseover: onMouseOverPreset, mouseout: onMouseOutPreset}">
                                    ` + this.presetFilter.getHtmlBuild() + `
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="block-filters">
                    <nav class="sidebar-default js-sidebar" data-bind="css: {'is-open': sidebarToggle()}">
                            <div class="sidebar-default-header">
                                <span class="label-default sidebar-default-header icon i-preferences">Report Preferences</span>
                                <button data-bind="event: { click: onSidebarToggle }" type="button" class="btn-close-default icon i-close"><span></span></button>
                            </div>

                            <div class="sidebar-default-body">
                                <div>
                                    <span class="label-default icon i-dimensions">Dimensions</span>
                                    <ul class="sidebar-default-list">
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Default">
                                                <span>Default</span>
                                                <input type="radio" id="radio-dimension-time" name="switch-dimension-group" value="time" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'time')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Device">
                                                <span>Device</span>
                                                <input type="radio" id="radio-dimension-device" name="switch-dimension-device" value="device" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'device')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Traffic Classification">
                                                <span>Traffic Classification</span>
                                                <input type="radio" id="radio-dimension-trafficClassification" name="switch-dimension-trafficClassification" value="trafficClassification" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'trafficClassification')}, checked: dimensionGroupSwitch "/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Device Model">
                                                <span>Device Model</span>
                                                <input type="radio" id="radio-dimension-deviceModel" name="switch-dimension-deviceModel" value="deviceModel" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'deviceModel')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Operating System">
                                                <span>Operating System</span>
                                                <input type="radio" id="radio-dimension-os" name="switch-dimension-os" value="os" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'os')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Browser">
                                                <span>Browser</span>
                                                <input type="radio" id="radio-dimension-browser" name="switch-dimension-browser" value="browser" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'browser')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Browser Version">
                                                <span>Browser Version</span>
                                                <input type="radio" id="radio-dimension-browserVersion" name="switch-dimension-browserVersion" value="browserVersion" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'browserVersion')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Ad Block">
                                                <span>Ad Block</span>
                                                <input type="radio" id="radio-dimension-adBlockerStatus" name="switch-dimension-adBlockerStatus" value="adBlockerStatus" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'adBlockerStatus')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="User Agent">
                                                <span>User Agent</span>
                                                <input type="radio" id="radio-dimension-userAgent" name="switch-dimension-userAgent" value="userAgent" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'userAgent')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Geo">
                                                <span>Geo</span>
                                                <input type="radio" id="radio-dimension-geo" name="switch-dimension-geo" value="geo" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'geo')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Region">
                                                <span>Region</span>
                                                <input type="radio" id="radio-dimension-region" name="switch-dimension-region" value="region" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'region')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="City">
                                                <span>City</span>
                                                <input type="radio" id="radio-dimension-city" name="switch-dimension-city" value="city" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'city')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Page Path">
                                                <span>Page Path</span>
                                                <input type="radio" id="radio-dimension-permalink" name="switch-dimension-permalink" value="permalink" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'permalink')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="AMP">
                                                <span>AMP</span>
                                                <input type="radio" id="radio-dimension-ampStatus" name="switch-dimension-ampStatus" value="ampStatus" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'ampStatus')}, checked: dimensionGroupSwitch "/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Referrer">
                                                <span>Referrer</span>
                                                <input type="radio" id="radio-dimension-referrer" name="switch-dimension-referrer" value="referrer" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'referrer')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Traffic Channel">
                                                <span>Traffic Channel</span>
                                                <input type="radio" id="radio-dimension-trafficChannel" name="switch-dimension-trafficChannel" value="trafficChannel" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'trafficChannel')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Hostname">
                                                <span>Hostname</span>
                                                <input type="radio" id="radio-dimension-hostname" name="switch-dimension-hostname" value="hostname" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'hostname')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="IP">
                                                <span>IP</span>
                                                <input type="radio" id="radio-dimension-ip" name="switch-dimension-ip" value="ip" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'ip')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Login Status">
                                                <span>Login Status</span>
                                                <input type="radio" id="radio-dimension-loginStatus" name="switch-dimension-loginStatus" value="loginStatus" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'loginStatus')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Plan">
                                                <span>Plan</span>
                                                <input type="radio" id="radio-dimension-plan" name="switch-dimension-plan" value="plan" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'plan')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Identity Source">
                                                <span>Identity Source</span>
                                                <input type="radio" id="radio-dimension-identity-source" name="switch-dimension-identity-source" value="identitySource" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'identitySource')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Robot Name">
                                                <span>Robot Name</span>
                                                <input type="radio" id="radio-dimension-robotName" name="switch-dimension-robotName" value="robotName" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'robotName')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Robot Category">
                                                <span>Robot Category</span>
                                                <input type="radio" id="radio-dimension-robotCategory" name="switch-dimension-robotCategory" value="robotCategory" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'robotCategory')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                    </ul>
                                </div>
                                <div>
                                    <span class="label-default icon i-dimensions">UTMs</span>
                                    <ul class="sidebar-default-list">
                                        <li>
                                            <label class="label-checkbox-menu-default" title="UTM Campaign">
                                                <span>UTM Campaign</span>
                                                <input type="radio" id="radio-dimension-utmCampaign" name="switch-dimension-utmCampaign" value="utmCampaign" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'utmCampaign')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="UTM Medium">
                                                <span>UTM Medium</span>
                                                <input type="radio" id="radio-dimension-utmMedium" name="switch-dimension-utmMedium" value="utmMedium" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'utmMedium')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="UTM Source">
                                                <span>UTM Source</span>
                                                <input type="radio" id="radio-dimension-utmSource" name="switch-dimension-utmSource" value="utmSource" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'utmSource')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                    </ul>
                                </div>
                                <!-- ko if: customDimensionsNames().length > 0 -->
                                    <div>
                                        <span class="label-default icon i-dimensions">Custom Dimensions</span>
                                        <ul class="sidebar-default-list">
                                            <!-- ko foreach: customDimensionsNames -->
                                                <li>
                                                    <label class="label-checkbox-menu-default" title="Default" data-bind="attr: {title: name}">
                                                        <span data-bind="text: name"></span>
                                                        <input type="radio" data-bind="attr: { id: 'radio-dimension-' + name, name: 'switch-dimension-' + name, value: name }, event: { change: $parent.onDimensionGroupSwitch.bind($parent, name) }, checked: $parent.dimensionGroupSwitch"/>                            </label>
                                                </li>
                                            <!-- /ko -->
                                        </ul>
                                    </div>
                                <!-- /ko -->
                            </div>
                        </nav>
                    <nav class="sidebar-default sidebar-default-right" data-bind="css:{'is-open': isFiltersOpen()}">
                        <div class="sidebar-default-header">
                            <span class="label-default sidebar-default-header icon i-filters">Filters</span>
                            <button type="button" class="btn-close-default icon i-close" data-bind="event: { click: toggleOpenFilters }"><span></span></button>
                        </div>

                        <div class="sidebar-default-body">

                            <div>

                                <!-- ko foreach: dynamicFiltersGrouped -->

                                    <span class="form-label" data-bind="text: categoryName"></span>

                                    <div class="dynamic-filters w-add-filters-list">

                                    <!-- ko foreach: Object.values(names) -->

                                        <!-- ko if:
                                            (!$parents[1].segmentsFilterException() || ($parents[1].segmentsFilterException() && name !== 'segment'))
                                            && (!$parents[1].systemsFilterException() || ($parents[1].systemsFilterException() && name !== 'system'))
                                        -->

                                            <div class="filter-group">

                                                <div class="checkbox-group">
                                                    <label class="icon i-dropdown-simple">
                                                        <input class="expected" type="checkbox" />
                                                    </label>
                                                </div>

                                                <!-- ko foreach: filters -->

                                                    <!-- ko if: type === 'multiSelect' -->
                                                        <div data-bind="template: {name: 'multiSelector-template', data: filter.getTemplateViewModel()}" class="has-multi"></div>
                                                    <!-- /ko -->

                                                    <!-- ko if: type === 'autoCompleteMultiSelect' -->
                                                        <div data-bind="template: {name: 'filterMultipleAutoComplete-template', data: filter.getTemplateViewModel()}"></div>
                                                    <!-- /ko -->

                                                    <!-- ko if: type === 'searchField' -->
                                                        <div data-bind="template: {name: 'filterSimple-template', data: filter.getTemplateViewModel()}"></div>
                                                    <!-- /ko -->

                                                <!-- /ko -->

                                            </div> <!-- End filter-group -->
                                        <!-- /ko -->
                                    <!-- /ko -->
                                    </div>
                                <!-- /ko -->

                            </div>
                        </div>
                    </nav>
                </div>
                <div class="w-filters-selected">
                    <div id="filters-selected" class="filters-selected">
                        <!-- ko foreach: dynamicFilters -->
                            <div data-bind="attr: { id: 'selected-' + name }"></div>
                        <!-- /ko -->
                    </div>
                </div>

                <div id="totals-results" style="min-height: 216px;" class="w-total-results">

                    <div class="w-cards-container">

                            <div id="totals-widget" class="w-card emphasis">

                            <!-- ko with: totalsData(), as: 'totalsData'  -->
                                <!-- ko with: totalsData.latestTotals, as: 'latestTotals' -->
                                <!-- ko with: totalsData.deltas, as: 'deltas' -->

                                        <div class="w-tooltips-adv auto-height short pos-right-tight" data-bind="template: { name: 'infoButton-template', data: $parents[2].getMainDashTooltip().getTemplateViewModel() }"></div>

                                        <!-- ko if: $parents[2].visitsViewsToggle() == 'views' -->
                                            <p class="title"><span class="live-indict icon i-live" data-bind="attr: { title: $parents[2].getNiceIntervalName() }"></span><span class="icon i-eye"></span>Total views<span data-bind="text: $parents[2].getNiceIntervalName() "></span></p>
                                            <div class="w-value">
                                                <p class="value" data-bind="text: Number(latestTotals.viewCountTotal).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></p>
                                                <div class="w-last-week">
                                                    <p data-bind="text: (deltas.viewCountDelta > 0 ? '+' : '') + Number(deltas.viewCountDelta).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%', attr: {class: deltas.viewCountDelta > 0 ? 'delta increase' : deltas.viewCountDelta < 0 ? 'delta decrease' : 'delta neutral'}"></p>

                                                    <!-- ko if: $parents[2].comparisonSwitch() == 'lastWeek' -->
                                                        <span class="label">Last Week<br> Comparison</span>
                                                    <!-- /ko -->
                                                    <!-- ko if: $parents[2].comparisonSwitch() == 'yesterday' -->
                                                        <span class="label">Yesterday<br>Comparison</span>
                                                    <!-- /ko -->
                                                </div>
                                            </div>
                                        <!-- /ko -->

                                        <!-- ko if: $parents[2].visitsViewsToggle() == 'visits' -->

                                            <p class="title"><span class="live-indict icon i-live" data-bind="attr: { title: $parents[2].getNiceIntervalName() }"></span><span class="icon i-eye"></span>Total visits<span data-bind="text: $parents[2].getNiceIntervalName() "></span></p>

                                            <div class="w-value">
                                                <p class="value" data-bind="text: Number(latestTotals.visitCountTotal).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></p>
                                                <div class="w-last-week">
                                                    <p data-bind="text: (deltas.visitCountDelta > 0 ? '+' : '') + Number(deltas.visitCountDelta).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%', attr: {class: deltas.visitCountDelta > 0 ? 'delta increase' : deltas.visitCountDelta < 0 ? 'delta decrease' : 'delta neutral'}"></p>

                                                    <!-- ko if: $parents[2].comparisonSwitch() == 'lastWeek' -->
                                                        <span class="label">Last Week<br> Comparison</span>
                                                    <!-- /ko -->
                                                    <!-- ko if: $parents[2].comparisonSwitch() == 'yesterday' -->
                                                        <span  class="label">Yesterday<br> Comparison</span>
                                                    <!-- /ko -->

                                                </div>
                                            </div>

                                        <!-- /ko -->

                                        <label class="btn-show-more icon i-dropdown-simple">
                                            <input type="checkbox">
                                        </label>


                                        <div class="emphasis-cards">
                                            <div class="w-card small">
                                                <!-- ko if: $parents[2].visitsViewsToggle() == 'views' -->
                                                    <p class="title"><span class="icon i-user-solid"></span>Logged-In Views</p>
                                                    <div class="w-value">
                                                        <p class="value" data-bind="text: Number(latestTotals.loggedInViewCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></p>
                                                    </div>
                                                    <div class="w-metrics">
                                                        <div class="w-last-week">
                                                            <p data-bind="text: (deltas.loggedInViewCountDelta > 0 ? '+' : '') + Number(deltas.loggedInViewCountDelta).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%', attr: {class: deltas.loggedInViewCountDelta > 0 ? 'delta increase' : deltas.loggedInViewCountDelta < 0 ? 'delta decrease' : 'delta neutral'}"></p>

                                                            <!-- ko if: $parents[2].comparisonSwitch() == 'lastWeek' -->
                                                                <span class="label">Last Week<br> Comparison</span>
                                                            <!-- /ko -->
                                                            <!-- ko if: $parents[2].comparisonSwitch() == 'yesterday' -->
                                                                <span class="label">Yesterday<br> Comparison</span>
                                                            <!-- /ko -->

                                                        </div>
                                                    </div>
                                                <!-- /ko -->
                                                <!-- ko if: $parents[2].visitsViewsToggle() == 'visits' -->
                                                    <p class="title"><span class="icon i-user-solid"></span>Logged-In Visits</p>
                                                    <div class="w-value">
                                                        <p class="value" data-bind="text: Number(latestTotals.loggedInVisitCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></p>
                                                    </div>
                                                    <div class="w-metrics">
                                                        <div class="w-last-week">
                                                            <p data-bind="text: (deltas.loggedInVisitCountDelta > 0 ? '+' : '') + Number(deltas.loggedInVisitCountDelta).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%', attr: {class: deltas.loggedInVisitCountDelta > 0 ? 'delta increase' : deltas.loggedInVisitCountDelta < 0 ? 'delta decrease' : 'delta neutral'}"></p>

                                                            <!-- ko if: $parents[2].comparisonSwitch() == 'lastWeek' -->
                                                                <span class="label">Last Week<br> Comparison</span>
                                                            <!-- /ko -->
                                                            <!-- ko if: $parents[2].comparisonSwitch() == 'yesterday' -->
                                                                <span class="label">Yesterday<br> Comparison</span>
                                                            <!-- /ko -->

                                                        </div>
                                                    </div>
                                                <!-- /ko -->
                                            </div>

                                            <div class="w-card small">
                                                <p class="title"><span class="icon i-user-solid"></span>Active Users</p>
                                                <div class="w-value">
                                                    <p class="value" data-bind="text: Number(latestTotals.activeUsers).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></p>
                                                </div>
                                                <div class="w-metrics">
                                                    <div class="w-last-week">
                                                    <p data-bind="text: (deltas.activeUsersDelta > 0 ? '+' : '') + Number(deltas.activeUsersDelta).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%', attr: {class: deltas.activeUsersDelta > 0 ? 'delta increase' : deltas.activeUsersDelta < 0 ? 'delta decrease' : 'delta neutral'}"></p>

                                                        <!-- ko if: $parents[2].comparisonSwitch() == 'lastWeek' -->
                                                            <span class="label">Last Week<br> Comparison</span>
                                                        <!-- /ko -->
                                                        <!-- ko if: $parents[2].comparisonSwitch() == 'yesterday' -->
                                                            <span class="label">Yesterday<br> Comparison</span>
                                                        <!-- /ko -->

                                                    </div>
                                                </div>
                                            </div>

                                            <div class="w-card small">
                                                <p class="title"><span class="icon i-arrow-pointer"></span>Scroll Depth %</p>
                                                <div class="w-value">
                                                    <p class="value" data-bind="text:  Number(latestTotals.avgViewEngagedDepthPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></p>
                                                </div>
                                                <div class="w-last-week">
                                                    <p data-bind="text: (deltas.viewEngagedDepthPercentagesDelta > 0 ? '+' : '') + Number(deltas.viewEngagedDepthPercentagesDelta).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%', attr: {class: deltas.viewEngagedDepthPercentagesDelta > 0 ? 'delta increase' : deltas.viewEngagedDepthPercentagesDelta < 0 ? 'delta decrease' : 'delta neutral'}"></p>

                                                    <!-- ko if: $parents[2].comparisonSwitch() == 'lastWeek' -->
                                                        <span class="label">Last Week<br> Comparison</span>
                                                    <!-- /ko -->
                                                    <!-- ko if: $parents[2].comparisonSwitch() == 'yesterday' -->
                                                        <span class="label">Yesterday<br> Comparison</span>
                                                    <!-- /ko -->

                                                </div>
                                            </div>

                                            <div class="w-card small">

                                                <p class="title"><span class="icon i-hourglass"></span>Avg. View Duration</p>
                                                <div class="w-value">
                                                    <p class="value" data-bind="text: latestTotals.avgViewEngagedSeconds"></p>
                                                </div>
                                                <div class="w-last-week">
                                                    <p data-bind="text: (deltas.viewEngagedSecondsDelta > 0 ? '+' : '') + Number(deltas.viewEngagedSecondsDelta).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%', attr: {class: deltas.viewEngagedSecondsDelta > 0 ? 'delta increase' : deltas.viewEngagedSecondsDelta < 0 ? 'delta decrease' : 'delta neutral'}"></p>

                                                    <!-- ko if: $parents[2].comparisonSwitch() == 'lastWeek' -->
                                                        <span class="label">Last Week<br> Comparison</span>
                                                    <!-- /ko -->
                                                    <!-- ko if: $parents[2].comparisonSwitch() == 'yesterday' -->
                                                        <span class="label">Yesterday<br> Comparison</span>
                                                    <!-- /ko -->

                                                </div>
                                            </div>
                                        </div>

                                        <!-- /ko -->
                                        <!-- /ko -->
                                    <!-- /ko -->

                                    </div>

                                <!-- ko with: totalsData(), as: 'totalsData'  -->
                                <!-- ko with: totalsData.latestTotals, as: 'latestTotals' -->
                                <!-- ko with: totalsData.deltas, as: 'deltas' -->

                                    <div class="w-card legacy-card-grid mobile-only" style="display: none">

                                        <div class="w-card">
                                            <p class="title"><span class="icon i-arrow-pointer"></span>Scroll Depth %</p>
                                            <div class="w-value">
                                                <p class="value" data-bind="text:  Number(latestTotals.avgViewEngagedDepthPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></p>
                                            </div>
                                            <div class="w-metrics">
                                                <div class="w-last-week">
                                                    <p data-bind="text: (deltas.viewEngagedDepthPercentagesDelta > 0 ? '+' : '') + Number(deltas.viewEngagedDepthPercentagesDelta).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%', attr: {class: deltas.viewEngagedDepthPercentagesDelta > 0 ? 'delta increase' : deltas.viewEngagedDepthPercentagesDelta < 0 ? 'delta decrease' : 'delta neutral'}"></p>

                                                    <!-- ko if: $parents[2].comparisonSwitch() == 'lastWeek' -->
                                                        <span class="label">Last Week<br> Comparison</span>
                                                    <!-- /ko -->
                                                    <!-- ko if: $parents[2].comparisonSwitch() == 'yesterday' -->
                                                        <span class="label">Yesterday<br> Comparison</span>
                                                    <!-- /ko -->
                                                </div>
                                            </div>
                                        </div>

                                        <div class="w-card">
                                            <p class="title"><span class="icon i-hourglass"></span>Avg. View Duration</p>
                                            <div class="w-value">
                                                <p class="value" data-bind="text: latestTotals.avgViewEngagedSeconds"></p>
                                            </div>
                                            <div class="w-metrics">
                                                <div class="w-last-week">
                                                    <p data-bind="text: (deltas.viewEngagedSecondsDelta > 0 ? '+' : '') + Number(deltas.viewEngagedSecondsDelta).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%', attr: {class: deltas.viewEngagedSecondsDelta > 0 ? 'delta increase' : deltas.viewEngagedSecondsDelta < 0 ? 'delta decrease' : 'delta neutral'}"></p>

                                                    <!-- ko if: $parents[2].comparisonSwitch() == 'lastWeek' -->
                                                        <span class="label">Last Week<br> Comparison</span>
                                                    <!-- /ko -->
                                                    <!-- ko if: $parents[2].comparisonSwitch() == 'yesterday' -->
                                                        <span class="label">Yesterday<br> Comparison</span>
                                                    <!-- /ko -->

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                            <!-- /ko -->
                            <!-- /ko -->
                        <!-- /ko -->

                        <div class="widget-grid-container">

                            <!-- ko foreach: reportWidgetColumnLayout -->

                                <div data-bind="style: { verticalAlign: 'top', boxSizing: 'border-box' }">

                                    <!-- ko ifnot: $data[1] && $data[1].widgetName -->
                                        <div data-bind="style: { height: '100%' }">
                                            <div class="w-card centered" data-bind="css: $parents[0].defaultDimensionColorClass()[$data[0].widgetName], attr: { id: $data[0] ? ('widgetLoading_' + $data[0].filterId) : '' }">
                                                <span class="live-indict icon i-live" data-bind=" attr: { title: $parents[0].getNiceIntervalName() } "></span>
                                                <span class="title icon" data-bind="text: $data[0].widgetName"></span>

                                                <!-- ko if: $data[0].widgetType == 'internalDimension' || $data[0].widgetType == 'customDimension' -->
                                                    <button class="btn-show-more icon i-dropdown-simple" type="button">
                                                        <span>show more</span>
                                                    </button>

                                                    <!-- ko if: $parents[0].getWidgetDataByKey($data[0].widgetName) -->
                                                        <!-- ko with: $parents[0].visitsViewsToggle() == 'views' ? $parents[0].getWidgetDataByKey($data[0].widgetName)[1] : $parents[0].getWidgetDataByKey($data[0].widgetName)[0], as: 'totalsData'  -->
                                                            <div class="w-value" data-bind="css: {'no-data' : totalsData.length == 0}">
                                                                <!-- ko foreach: totalsData -->
                                                                    <span class="label" title="select" data-bind="text: $data.dimension, event: {click: $parents[2].toggleWidgetFilter.bind(this,$data,$parents[1][0].filterId)}, css: {'is-selected' : $parents[2].isWidgetItemSelected($data,$parents[1][0].filterId)}"></span>
                                                                    <div class="value-delta">
                                                                        <span class="value" data-bind="text: Number($parents[2].visitsViewsToggle() == 'views' ? $data.viewCount : $data.visitCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                                        <span class="delta " data-bind="text: $parents[2].totalsData() ? Number($parents[2].getPercentOfTotal($data)).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%' : '-' "></span>
                                                                    </div>
                                                                <!-- /ko -->
                                                            </div>
                                                        <!-- /ko -->
                                                    <!-- /ko -->
                                                <!-- /ko -->

                                                <!-- ko if: $data[0].widgetType == 'graph'  -->

                                                    <!-- ko if: $data[0].widgetName == 'Ping Graph'  -->
                                                        <div data-bind="template: { name: 'amCharts_v4_date_basic_template', data: $parents[0].pingDiffIndicatorsChart }"></div>
                                                    <!-- /ko -->

                                                    <!-- ko if: $data[0].widgetName == 'Ping Load Time'  -->
                                                        <div data-bind="template: { name: 'amCharts_v4_date_basic_template', data: $parents[0].pingAvgLoadIndicatorsChart }"></div>
                                                    <!-- /ko -->
                                                <!-- /ko -->
                                            </div>
                                        </div>
                                    <!-- /ko -->

                                    <!-- ko if: $data[1] && $data[1].widgetName -->
                                        <div data-bind="style: { height: '50%' }">
                                            <div class="w-card centered" data-bind="css: $parents[0].defaultDimensionColorClass()[$data[0].widgetName], attr: { id: $data[0] ? ('widgetLoading_' + $data[0].filterId) : '' }">
                                                <span class="live-indict icon i-live" data-bind=" attr: { title: $parents[0].getNiceIntervalName() } "></span>
                                                <span class="title icon " data-bind="text: $data[0].widgetName"></span>

                                                <!-- ko if: $data[0].widgetType == 'internalDimension' || $data[0].widgetType == 'customDimension' -->
                                                    <button class="btn-show-more icon i-dropdown-simple" type="button">
                                                        <span>show more</span>
                                                    </button>

                                                    <!-- ko if: $parents[0].getWidgetDataByKey($data[0].widgetName) -->
                                                        <!-- ko with: $parents[0].visitsViewsToggle() == 'views' ? $parents[0].getWidgetDataByKey($data[0].widgetName)[1] : $parents[0].getWidgetDataByKey($data[0].widgetName)[0], as: 'totalsData'  -->
                                                            <div class="w-value" data-bind="css: {'no-data' : totalsData.length == 0}">
                                                                <!-- ko foreach: totalsData.slice(0, 2) -->
                                                                    <span class="label" title="select" data-bind="text: $data.dimension, event: {click: $parents[2].toggleWidgetFilter.bind(this,$data,$parents[1][0].filterId)}, css: {'is-selected' : $parents[2].isWidgetItemSelected($data,$parents[1][0].filterId)}"></span>
                                                                    <div class="value-delta">
                                                                        <span class="value" data-bind="text: Number($parents[2].visitsViewsToggle() == 'views' ? $data.viewCount : $data.visitCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                                        <span class="delta " data-bind="text: $parents[2].totalsData() ? Number($parents[2].getPercentOfTotal($data)).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%' : '-' "></span>
                                                                    </div>
                                                                <!-- /ko -->
                                                            </div>
                                                        <!-- /ko -->
                                                    <!-- /ko -->
                                                <!-- /ko -->

                                                <!-- ko if: $data[0].widgetType == 'graph'  -->

                                                    <!-- ko if: $data[0].widgetName == 'Ping Graph'  -->
                                                        <div data-bind="template: { name: 'amCharts_v4_date_basic_template', data: $parents[0].pingDiffIndicatorsChart }"></div>
                                                    <!-- /ko -->

                                                    <!-- ko if: $data[0].widgetName == 'Ping Load Time'  -->
                                                        <div data-bind="template: { name: 'amCharts_v4_date_basic_template', data: $parents[0].pingAvgLoadIndicatorsChart }"></div>
                                                    <!-- /ko -->
                                                <!-- /ko -->
                                            </div>
                                        </div>

                                        <div data-bind="style: { height: '50%' }">
                                            <div class="w-card centered" data-bind="css: $parents[0].defaultDimensionColorClass()[$data[1].widgetName], attr: { id: $data[1] ? ('widgetLoading_' + $data[1].filterId) : '' }">
                                                <span class="live-indict icon i-live" data-bind=" attr: { title: $parents[0].getNiceIntervalName() } "></span>
                                                <span class="title icon " data-bind="text: $data[1].widgetName"></span>

                                                <!-- ko if: $data[1].widgetType == 'internalDimension' || $data[1].widgetType == 'customDimension' -->
                                                    <button class="btn-show-more icon i-dropdown-simple" type="button">
                                                        <span>show more</span>
                                                    </button>

                                                    <!-- ko if: $parents[0].getWidgetDataByKey($data[1].widgetName) -->
                                                        <!-- ko with: $parents[0].visitsViewsToggle() == 'views' ? $parents[0].getWidgetDataByKey($data[1].widgetName)[1] : $parents[0].getWidgetDataByKey($data[1].widgetName)[0], as: 'totalsData'  -->
                                                            <div class="w-value" data-bind="css: {'no-data' : totalsData.length == 0}">
                                                                <!-- ko foreach: totalsData.slice(0, 2) -->
                                                                    <span class="label" title="select" data-bind="text: $data.dimension, event: {click: $parents[2].toggleWidgetFilter.bind(this,$data,$parents[1][1].filterId)}, css: {'is-selected' : $parents[2].isWidgetItemSelected($data,$parents[1][1].filterId)}"></span>
                                                                    <div class="value-delta">
                                                                        <span class="value" data-bind="text: Number($parents[2].visitsViewsToggle() == 'views' ? $data.viewCount : $data.visitCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                                        <span class="delta " data-bind="text:  $parents[2].totalsData() ? Number($parents[2].getPercentOfTotal($data)).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%' : '-'"></span>
                                                                    </div>
                                                                <!-- /ko -->
                                                            </div>
                                                        <!-- /ko -->
                                                    <!-- /ko -->
                                                <!-- /ko -->

                                                    <div>
                                                        <!-- ko if: $data[1].widgetType == 'graph' && $data[1].widgetName == 'Ping Graph'  -->
                                                            <div data-bind="template: { name: 'amCharts_v4_date_basic_template', data: $parents[0].pingDiffIndicatorsChart }"></div>
                                                        <!-- /ko -->
                                                    </div>

                                                    <div>
                                                        <!-- ko if: $data[1].widgetType == 'graph' && $data[1].widgetName == 'Ping Load Time'  -->
                                                            <div data-bind="template: { name: 'amCharts_v4_date_basic_template', data: $parents[0].pingAvgLoadIndicatorsChart }"></div>
                                                        <!-- /ko -->
                                                    </div>
                                            </div>
                                        </div>
                                    <!-- /ko -->
                                </div>
                            <!-- /ko -->
                        </div>
                    </div>
                </div>

                <!-- ko if: sampledDatesData() && sampledDatesData().length > 0 -->
                    <div class="w-block-message plus theme-light">
                        <div class="block-message-content">
                            <p><strong>Note:</strong> The selected date range includes periods where data was sampled.</p>
                        </div>
                    </div>
                <!-- /ko -->

                <div class="w-graph block-default rogue no-padding" id="indicatorsByDate-results">
                    <div class="w-justify" style="width: 100%;margin-right: 1rem;margin-top: 1rem">
                        <div class="w-right" data-bind= "visible: timelineAnnotationsData().length">
                            <span class="label-annotation"></span>
                            <div class="w-tooltips-adv auto-height short pos-top-left">
                                ${this.annotationTooltip.getHtmlBuild()}
                            </div>
                        </div>
                    </div>

                    <div class="graph">
                        <button class="button-default icon i-refresh no-after" data-bind="event: {click: clearSnapshot}, visible: snapshotDateTime()">Reset</button>
                        ${this.indicatorsChart.getHtmlBuild()}
                    </div>
                </div>

                <!-- ko if: showTableDimensions() -->

                    <div class="list-results-header w-justify">
                        <div class="w-left"><p class="title"><span class="live-indict icon i-live"></span><span class="icon i-pages"></span><!-- ko text: getDimensionNiceName() --><!-- /ko --><span data-bind="text: getNiceIntervalName()"></span></p></div>
                        <div class="w-right live-dashboard-header-controls">
                            <div class="live-dashboard-header-controls-track">
                                <div class="live-dashboard-relative-performance">
                                    ` + this.deltaFilter.getHtmlBuild() + `
                                    <div class="w-tooltips-adv auto-height short pos-bottom relative-performance-tooltip" data-bind="template: { name: 'infoButton-template', data: getRelativePerformanceTooltip().getTemplateViewModel() }"></div>
                                </div>
                                <div class="separator"></div>
                                ` + this.pagination.getHtmlBuild() + `
                            </div>
                        </div>
                    </div>
                    <div id="topArticles-results" class="gradient-overflow " style="min-height: 200px;">
                        <div class="w-list-results " data-bind="css: {'no-data' : tableDimensionsData().length == 0}" style="min-height: 200px;">
                            <table data-bind="visible: tableDimensionsData().length > 0" class="list-results thin live-dashboard-table">
                                <thead>
                                    <tr>
                                        <th class="table-numeric">
                                            <span class=" icon list-sort-none">Rank</span>
                                        </th>
                                        <th>
                                            <span  data-bind="event: {click: onReorderTableData.bind(this, $data, 'dimension')}, css: {'i-sort-up': tableOrdering().col == 'dimension' && tableOrdering().dir == 'ASC', 'i-sort-down': tableOrdering().col == 'dimension' && tableOrdering().dir == 'DESC'}" class="icon icon i-sort">Dimension</span>
                                        </th>
                                        <!-- ko if: visitsViewsToggle() == 'visits' -->
                                            <th class="table-numeric">
                                                <span  data-bind="event: {click: onReorderTableData.bind(this, $data, 'visitCount')}, css: {'i-sort-up': tableOrdering().col == 'visitCount' && tableOrdering().dir == 'ASC', 'i-sort-down': tableOrdering().col == 'visitCount' && tableOrdering().dir == 'DESC'}" class="icon i-sort">Visits</span>
                                            </th>
                                        <!-- /ko -->
                                        <!-- ko if: visitsViewsToggle() == 'views' -->
                                            <th class="table-numeric">
                                                <span data-bind="event: {click: onReorderTableData.bind(this, $data, 'viewCount')}, css: {'i-sort-up': tableOrdering().col == 'viewCount' && tableOrdering().dir == 'ASC', 'i-sort-down': tableOrdering().col == 'viewCount' && tableOrdering().dir == 'DESC'}" class="icon i-sort">Views</span>
                                            </th>
                                        <!-- /ko -->
                                        <th class="table-numeric">
                                            <span data-bind="event: {click: onReorderTableData.bind(this, $data, 'avgViewEngagedSeconds')}, css: {'i-sort-up': tableOrdering().col == 'avgViewEngagedSeconds' && tableOrdering().dir == 'ASC', 'i-sort-down': tableOrdering().col == 'avgViewEngagedSeconds' && tableOrdering().dir == 'DESC'}" class="icon i-sort">AVD</span>
                                        </th>
                                        <th class="table-numeric">
                                            <span data-bind="event: {click: onReorderTableData.bind(this, $data, 'avgViewEngagedDepthPercentage')}, css: {'i-sort-up': tableOrdering().col == 'avgViewEngagedDepthPercentage' && tableOrdering().dir == 'ASC', 'i-sort-down': tableOrdering().col == 'avgViewEngagedDepthPercentage' && tableOrdering().dir == 'DESC'}" class="icon i-sort">Scroll Depth %</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <!-- ko foreach: tableDimensionsData -->
                                        <tr data-bind="style: { 'background-color': $parent.selectedRows().indexOf($index()) !== -1 ? '#dbdbed' : '' }">
                                            <td class="table-numeric">
                                                <span data-bind="text: ($index()+1) + $parent.pageOffset()"></span>
                                            </td>


                                            <!-- ko if: $parent.dimensionGroupSwitch() == 'permalink' -->
                                                <td>
                                                    <a data-bind="event: { click: $parent.stopPropagation }, attr: {href: '/permalink_details?' + $parent.getEncodedViewModelParams() + '&brand=' + brand + '&permalink=' + $data.permalinkUrl}">
                                                        <span class="ios-font-fix" data-bind="text: $data.subdomain && $data.subdomain != 'www' ? ($data.subdomain + ' ... ' + $data.dimension) : $data.dimension"></span>
                                                    </a>
                                                    <a class="icon i-ext-link" data-bind="event: { click: $parent.stopPropagation }, attr: {href: $data.permalinkUrl}" target="_blank"></a>
                                                </td>
                                            <!-- /ko -->

                                            <!-- ko if: $parent.dimensionGroupSwitch() != 'permalink' -->
                                                <td>
                                                    <span data-bind="text: $data.dimension"></span>
                                                </td>
                                            <!-- /ko -->

                                            <!-- ko if: $parents[0].visitsViewsToggle() == 'visits' -->
                                                <td class="table-numeric">
                                                    <span data-bind="text: $data.visitCount"></span>
                                                </td>
                                            <!-- /ko -->
                                            <!-- ko if: $parents[0].visitsViewsToggle() == 'views' -->
                                                <td class="table-numeric">
                                                    <span data-bind="text: $data.viewCount"></span>
                                                </td>
                                            <!-- /ko -->
                                            <td class="table-numeric">
                                                <div class="table-metric-cell">
                                                    <span data-bind="text: $parent.formatMinuteSeconds($data.avgViewEngagedSeconds)"></span>
                                                    <span class="table-metric-delta delta" data-bind="visible: $parent.hasTableDelta($data.avgViewEngagedSecondsDelta), text: $parent.formatTableDelta($data.avgViewEngagedSecondsDelta), css: {'increase': Math.round(Number($data.avgViewEngagedSecondsDelta)) > 0, 'decrease': Math.round(Number($data.avgViewEngagedSecondsDelta)) < 0, 'neutral': Math.round(Number($data.avgViewEngagedSecondsDelta)) === 0}"></span>
                                                </div>
                                            </td>
                                            <td class="table-numeric">
                                                <div class="table-metric-cell">
                                                    <span data-bind="text: $parent.formatNullablePercentage($data.avgViewEngagedDepthPercentage)"></span>
                                                    <span class="table-metric-delta delta" data-bind="visible: $parent.hasTableDelta($data.avgViewEngagedDepthPercentageDelta), text: $parent.formatTableDelta($data.avgViewEngagedDepthPercentageDelta), css: {'increase': Math.round(Number($data.avgViewEngagedDepthPercentageDelta)) > 0, 'decrease': Math.round(Number($data.avgViewEngagedDepthPercentageDelta)) < 0, 'neutral': Math.round(Number($data.avgViewEngagedDepthPercentageDelta)) === 0}"></span>
                                                </div>
                                            </td>
                                        </tr>
                                    <!-- /ko -->
                                </tbody>
                            </table>
                        </div>
                    </div>
                <!-- /ko -->

                <!-- ko if: !showTableDimensions() -->

                    <div class="list-results-header w-justify">
                        <div class="w-left">
                            <div class="live-dashboard-top-pages-title">
                                <p class="title"><span class="live-indict icon i-live"></span><span class="icon i-pages"></span>Top Pages<span data-bind="text: getNiceIntervalName()"></span></p>
                                <div id="top-pages-brand-filter" class="w-brand-filter live-dashboard-top-pages-brand-filter">
                                    <div class="w-single-multi-level dropdown" data-bind="css: { 'is-visible': isTopPagesBrandFilterOpen }">
                                        <button class="dropdown-toggle" type="button" data-bind="click: toggleTopPagesBrandFilter">
                                            <label class="form-label" for="" data-bind="text: brandFilter.label"></label>

                                            <!-- ko if: brandFilter.hasLogo() && brandFilter.getSelectedOptionLogo() && brandFilter.isCssLogo() -->
                                                <label class="bsa-label full-icon" data-bind="css: brandFilter.getSelectedOptionLogo()"></label>
                                            <!-- /ko -->

                                            <!-- ko if: brandFilter.hasLogo() && brandFilter.getSelectedOptionLogo() && !brandFilter.isCssLogo() -->
                                                <img data-bind="attr: {src: brandFilter.getSelectedOptionLogo()}" alt="dropdown">
                                            <!-- /ko -->

                                            <!-- ko if: brandFilter.hasLogo() && !brandFilter.getSelectedOptionLogo() && brandFilter.isDefaultLogoDefined() -->
                                                <img data-bind="attr: {src: brandFilter.defaultLogo()}" alt="dropdown">
                                            <!-- /ko -->

                                            <span data-bind="text: brandFilter.selectedOptionText"></span>
                                        </button>

                                        <ul class="bsa-list-first dropdown-list">
                                            <!-- ko foreach: brandFilter.groups -->
                                                <li>
                                                    <label class="bsa-label full-icon">
                                                        <!-- ko if: !$data.cssClasses && !$data.iconUrl && $parent.brandFilter.isDefaultLogoDefined() -->
                                                            <img data-bind="attr: {src: $parent.brandFilter.defaultLogo()}" alt="dropdown">
                                                        <!-- /ko -->

                                                        <!-- ko if: $data.iconUrl && !$data.cssClasses -->
                                                            <img data-bind="attr: {src: $data.iconUrl}" alt="dropdown">
                                                        <!-- /ko -->

                                                        <!-- ko if: $data.cssClasses && !$data.iconUrl -->
                                                            <label class="bsa-label full-icon" data-bind="css: $data.cssClasses ? $data.cssClasses : ''"></label>
                                                        <!-- /ko -->

                                                        <input type="radio" name="topPagesBrandFilter" data-bind="value: id, checked: $parent.brandFilter.selectedOption, attr: { id: 'top-pages-brand-filter-option-' + id }, event: { change: $parent.onTopPagesBrandOptionChange }">
                                                        <span data-bind="text: name"></span>
                                                    </label>

                                                    <!-- ko if: $data.subGroups -->
                                                        <ul class="bsa-list-second">
                                                            <!-- ko foreach: subGroups -->
                                                                <li>
                                                                    <label class="bsa-label full-icon">
                                                                        <!-- ko if: $parents[1].brandFilter.hasLogo() && $data.iconUrl != null -->
                                                                            <img data-bind="attr: {src: $data.iconUrl}" alt="dropdown">
                                                                        <!-- /ko -->

                                                                        <!-- ko if: $parents[1].brandFilter.hasLogo() && $data.iconUrl == null && $parents[1].brandFilter.isDefaultLogoDefined() -->
                                                                            <img data-bind="attr: {src: $parents[1].brandFilter.defaultLogo()}" alt="dropdown">
                                                                        <!-- /ko -->

                                                                        <input type="radio" name="topPagesBrandFilter" data-bind="value: id, checked: $parents[1].brandFilter.selectedOption, attr: { id: 'top-pages-brand-filter-option-' + id }, event: { change: $parents[1].onTopPagesBrandOptionChange }">
                                                                        <span data-bind="text: name"></span>
                                                                    </label>
                                                                </li>
                                                            <!-- /ko -->
                                                        </ul>
                                                    <!-- /ko -->
                                                </li>
                                            <!-- /ko -->
                                        </ul>
                                    </div>
                                </div>
                                <div class="live-dashboard-relative-performance">
                                    ` + this.deltaFilter.getHtmlBuild() + `
                                </div>
                                <div class="top-pages-v2-metric-toggles" aria-label="Optional engagement columns">
                                    <button class="top-pages-v2-metric-toggle" type="button" data-bind="event: { click: toggleMetricColumn.bind($data, 'avgViewEngagedSeconds') }, css: { 'is-active': isMetricColumnVisible('avgViewEngagedSeconds') }, attr: { 'aria-pressed': isMetricColumnVisible('avgViewEngagedSeconds'), title: isMetricColumnVisible('avgViewEngagedSeconds') ? 'Hide AVD column' : 'Show AVD column' }">
                                        <span class="icon" data-bind="css: { 'i-simplify': isMetricColumnVisible('avgViewEngagedSeconds'), 'i-expand': !isMetricColumnVisible('avgViewEngagedSeconds') }" aria-hidden="true"></span>
                                        <span>AVD</span>
                                    </button>
                                    <button class="top-pages-v2-metric-toggle" type="button" data-bind="event: { click: toggleMetricColumn.bind($data, 'engagedBreakdown') }, css: { 'is-active': isMetricColumnVisible('engagedBreakdown') }, attr: { 'aria-pressed': isMetricColumnVisible('engagedBreakdown'), title: isMetricColumnVisible('engagedBreakdown') ? 'Hide 30s, 60s and 90s columns' : 'Show 30s, 60s and 90s columns' }">
                                        <span class="icon" data-bind="css: { 'i-simplify': isMetricColumnVisible('engagedBreakdown'), 'i-expand': !isMetricColumnVisible('engagedBreakdown') }" aria-hidden="true"></span>
                                        <span>30s / 60s / 90s</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="w-right live-dashboard-header-controls">
                            <div class="live-dashboard-header-controls-track">
                                ` + this.pagination.getHtmlBuild() + `
                            </div>
                        </div>
                    </div>
                    <div id="topArticles-results" class="gradient-overflow" style="min-height: 200px;">
                        <div class="w-list-results " data-bind="css: {'no-data' : topArticlesData().length == 0}" style="min-height: 200px;">
                            <table data-bind="visible: topArticlesData().length > 0, css: { 'is-expanded': isMetricColumnVisible('avgViewEngagedSeconds') || isMetricColumnVisible('engagedBreakdown') }" class="list-results thin live-dashboard-top-pages-table-v2">
                                <colgroup>
                                    <col class="top-pages-v2-column-rank">
                                    <col class="top-pages-v2-column-property">
                                    <!-- ko if: segmentsFilterException() -->
                                        <col class="top-pages-v2-column-context top-pages-v2-column-segment">
                                    <!-- /ko -->
                                    <!-- ko if: systemsFilterException() -->
                                        <col class="top-pages-v2-column-context top-pages-v2-column-system">
                                    <!-- /ko -->
                                    <col class="top-pages-v2-column-page-path">
                                    <col class="top-pages-v2-column-metric">
                                    <col class="top-pages-v2-column-metric">
                                    <col class="top-pages-v2-column-metric">
                                    <!-- ko if: isMetricColumnVisible('engagedBreakdown') -->
                                        <col class="top-pages-v2-column-metric">
                                        <col class="top-pages-v2-column-metric">
                                        <col class="top-pages-v2-column-metric">
                                    <!-- /ko -->
                                    <!-- ko if: isMetricColumnVisible('avgViewEngagedSeconds') -->
                                        <col class="top-pages-v2-column-metric">
                                    <!-- /ko -->
                                    <col class="top-pages-v2-column-metric">
                                    <col class="top-pages-v2-column-metric">
                                    <!-- ko if: usColumnException() && (device() == 'desktop' || (device() == 'mobile' && deviceView() == 'desktop')) -->
                                        <col class="top-pages-v2-column-metric">
                                    <!-- /ko -->
                                    <!-- ko if: cpmColumnVisible() -->
                                        <col class="top-pages-v2-column-cpm">
                                    <!-- /ko -->
                                </colgroup>
                                <thead>
                                    <tr class="top-pages-v2-groups">
                                        <th class="top-pages-v2-context-group" scope="colgroup" aria-label="Page details" data-bind="attr: { colspan: 3 + (segmentsFilterException() ? 1 : 0) + (systemsFilterException() ? 1 : 0) }"></th>
                                        <th class="top-pages-v2-group top-pages-v2-group--traffic" scope="colgroup">Traffic</th>
                                        <th class="top-pages-v2-group top-pages-v2-group--engagement" scope="colgroup" data-bind="attr: { colspan: 4 + (isMetricColumnVisible('avgViewEngagedSeconds') ? 1 : 0) + (isMetricColumnVisible('engagedBreakdown') ? 3 : 0) }">Engagement</th>
                                        <!-- ko if: (usColumnException() && (device() == 'desktop' || (device() == 'mobile' && deviceView() == 'desktop'))) || cpmColumnVisible() -->
                                            <th class="top-pages-v2-group top-pages-v2-group--commercial" scope="colgroup" data-bind="attr: { colspan: ((usColumnException() && (device() == 'desktop' || (device() == 'mobile' && deviceView() == 'desktop'))) ? 1 : 0) + (cpmColumnVisible() ? 1 : 0) }"><span class="top-pages-v2-commercial-label">Marketability</span></th>
                                        <!-- /ko -->
                                    </tr>
                                    <tr class="top-pages-v2-labels">
                                        <th class="top-pages-v2-number">#</th>
                                        <th>Brand</th>
                                        <!-- ko if: segmentsFilterException() -->
                                            <th>Segment</th>
                                        <!-- /ko -->
                                        <!-- ko if: systemsFilterException() -->
                                            <th class="top-pages-v2-system">System</th>
                                        <!-- /ko -->
                                        <th><button type="button" data-bind="event: {click: onReorderTableData.bind(this, $data, 'permalink')}, css: {'i-sort-up': tableOrdering().col == 'permalink' && tableOrdering().dir == 'ASC', 'i-sort-down': tableOrdering().col == 'permalink' && tableOrdering().dir == 'DESC'}" class="top-pages-v2-sort icon i-sort">Page Path</button></th>
                                        <!-- ko if: visitsViewsToggle() == 'visits' -->
                                            <th class="top-pages-v2-number top-pages-v2-group-boundary top-pages-v2-traffic-column top-pages-v2-visits-column"><button type="button" data-bind="event: {click: onReorderTableData.bind(this, $data, 'visitCount')}, css: {'i-sort-up': tableOrdering().col == 'visitCount' && tableOrdering().dir == 'ASC', 'i-sort-down': tableOrdering().col == 'visitCount' && tableOrdering().dir == 'DESC'}" class="top-pages-v2-sort icon i-sort">Visits</button></th>
                                        <!-- /ko -->
                                        <!-- ko if: visitsViewsToggle() == 'views' -->
                                            <th class="top-pages-v2-number top-pages-v2-group-boundary top-pages-v2-traffic-column top-pages-v2-visits-column"><button type="button" data-bind="event: {click: onReorderTableData.bind(this, $data, 'viewCount')}, css: {'i-sort-up': tableOrdering().col == 'viewCount' && tableOrdering().dir == 'ASC', 'i-sort-down': tableOrdering().col == 'viewCount' && tableOrdering().dir == 'DESC'}" class="top-pages-v2-sort icon i-sort">Views</button></th>
                                        <!-- /ko -->
                                        <th class="top-pages-v2-number top-pages-v2-tooltip-header top-pages-v2-group-boundary top-pages-v2-engagement-column">
                                            <div class="top-pages-v2-header-content">
                                                <button type="button" data-bind="event: {click: onReorderTableData.bind(this, $data, getEngagedOrderColumn())}, css: {'i-sort-up': tableOrdering().col == getEngagedOrderColumn() && tableOrdering().dir == 'ASC', 'i-sort-down': tableOrdering().col == getEngagedOrderColumn() && tableOrdering().dir == 'DESC'}" class="top-pages-v2-sort"><span class="icon i-sort" data-bind="text: visitsViewsToggle() == 'visits' ? 'Eng. Visits' : 'Eng. Views'"></span></button>
                                                <div class="w-tooltips-adv auto-height short pos-right-tight in-list engagement-tooltip" data-bind="template: { name: 'infoButton-template', data: getEngagedPagesTooltip().getTemplateViewModel() }"></div>
                                            </div>
                                        </th>
                                        <!-- ko if: isMetricColumnVisible('engagedBreakdown') -->
                                            <th class="top-pages-v2-number top-pages-v2-tooltip-header top-pages-v2-engagement-column top-pages-v2-expanded-column top-pages-v2-expanded-column--start"><div class="top-pages-v2-header-content"><span class="top-pages-v2-sort top-pages-v2-duration-label">30s+</span><div class="w-tooltips-adv auto-height short pos-right-tight in-list engagement-tooltip" data-bind="template: { name: 'infoButton-template', data: getEngagedBreakdownTooltip('30s').getTemplateViewModel() }"></div></div></th>
                                            <th class="top-pages-v2-number top-pages-v2-tooltip-header top-pages-v2-engagement-column top-pages-v2-expanded-column"><div class="top-pages-v2-header-content"><span class="top-pages-v2-sort top-pages-v2-duration-label">60s+</span><div class="w-tooltips-adv auto-height short pos-right-tight in-list engagement-tooltip" data-bind="template: { name: 'infoButton-template', data: getEngagedBreakdownTooltip('60s').getTemplateViewModel() }"></div></div></th>
                                            <th class="top-pages-v2-number top-pages-v2-tooltip-header top-pages-v2-engagement-column top-pages-v2-expanded-column top-pages-v2-expanded-column--end"><div class="top-pages-v2-header-content"><span class="top-pages-v2-sort top-pages-v2-duration-label">90s+</span><div class="w-tooltips-adv auto-height short pos-right-tight in-list engagement-tooltip" data-bind="template: { name: 'infoButton-template', data: getEngagedBreakdownTooltip('90s').getTemplateViewModel() }"></div></div></th>
                                        <!-- /ko -->
                                        <th class="top-pages-v2-number top-pages-v2-tooltip-header top-pages-v2-engagement-column top-pages-v2-interaction-ratio">
                                            <div class="top-pages-v2-header-content"><button type="button" data-bind="event: {click: onReorderTableData.bind(this, $data, 'interactionRatio')}, css: {'i-sort-up': tableOrdering().col == 'interactionRatio' && tableOrdering().dir == 'ASC', 'i-sort-down': tableOrdering().col == 'interactionRatio' && tableOrdering().dir == 'DESC'}" class="top-pages-v2-sort"><span class="icon i-sort">Int. Ratio</span></button><div class="w-tooltips-adv auto-height short pos-right-tight in-list engagement-tooltip" data-bind="template: { name: 'infoButton-template', data: getInteractionRatioTooltip().getTemplateViewModel() }"></div></div>
                                        </th>
                                        <th class="top-pages-v2-number top-pages-v2-tooltip-header top-pages-v2-engagement-column">
                                            <div class="top-pages-v2-header-content"><button type="button" data-bind="event: {click: onReorderTableData.bind(this, $data, 'avgTimeOnPageSeconds')}, css: {'i-sort-up': tableOrdering().col == 'avgTimeOnPageSeconds' && tableOrdering().dir == 'ASC', 'i-sort-down': tableOrdering().col == 'avgTimeOnPageSeconds' && tableOrdering().dir == 'DESC'}" class="top-pages-v2-sort"><span class="icon i-sort">TᴏP</span></button><div class="w-tooltips-adv auto-height short pos-right-tight in-list engagement-tooltip" data-bind="template: { name: 'infoButton-template', data: getTimeOnPageTooltip().getTemplateViewModel() }"></div></div>
                                        </th>
                                        <!-- ko if: isMetricColumnVisible('avgViewEngagedSeconds') -->
                                            <th class="top-pages-v2-number top-pages-v2-tooltip-header top-pages-v2-engagement-column top-pages-v2-expanded-column top-pages-v2-expanded-column--start top-pages-v2-expanded-column--end"><div class="top-pages-v2-header-content"><button type="button" data-bind="event: {click: onReorderTableData.bind(this, $data, 'avgViewEngagedSeconds')}, css: {'i-sort-up': tableOrdering().col == 'avgViewEngagedSeconds' && tableOrdering().dir == 'ASC', 'i-sort-down': tableOrdering().col == 'avgViewEngagedSeconds' && tableOrdering().dir == 'DESC'}" class="top-pages-v2-sort icon i-sort">AVD</button><div class="w-tooltips-adv auto-height short pos-right-tight in-list engagement-tooltip" data-bind="template: { name: 'infoButton-template', data: getAvgViewDurationTooltip().getTemplateViewModel() }"></div></div></th>
                                        <!-- /ko -->
                                        <th class="top-pages-v2-number top-pages-v2-engagement-column top-pages-v2-depth-column"><button type="button" data-bind="event: {click: onReorderTableData.bind(this, $data, 'avgViewEngagedDepthPercentage')}, css: {'i-sort-up': tableOrdering().col == 'avgViewEngagedDepthPercentage' && tableOrdering().dir == 'ASC', 'i-sort-down': tableOrdering().col == 'avgViewEngagedDepthPercentage' && tableOrdering().dir == 'DESC'}" class="top-pages-v2-sort icon i-sort">Depth</button></th>
                                        <!-- ko if: usColumnException() && visitsViewsToggle() == 'visits' && (device() == 'desktop' || (device() == 'mobile' && deviceView() == 'desktop')) -->
                                            <th class="top-pages-v2-number top-pages-v2-group-boundary top-pages-v2-commercial-column top-pages-v2-us-column"><button type="button" data-bind="event: {click: onReorderTableData.bind(this, $data, 'usVisitPercentage')}, css: {'i-sort-up': tableOrdering().col == 'usVisitPercentage' && tableOrdering().dir == 'ASC', 'i-sort-down': tableOrdering().col == 'usVisitPercentage' && tableOrdering().dir == 'DESC'}" class="top-pages-v2-sort icon i-sort">US %</button></th>
                                        <!-- /ko -->
                                        <!-- ko if: usColumnException() && visitsViewsToggle() == 'views' && (device() == 'desktop' || (device() == 'mobile' && deviceView() == 'desktop')) -->
                                            <th class="top-pages-v2-number top-pages-v2-group-boundary top-pages-v2-commercial-column top-pages-v2-us-column"><button type="button" data-bind="event: {click: onReorderTableData.bind(this, $data, 'usViewPercentage')}, css: {'i-sort-up': tableOrdering().col == 'usViewPercentage' && tableOrdering().dir == 'ASC', 'i-sort-down': tableOrdering().col == 'usViewPercentage' && tableOrdering().dir == 'DESC'}" class="top-pages-v2-sort icon i-sort">US %</button></th>
                                        <!-- /ko -->
                                        <!-- ko if: cpmColumnVisible() -->
                                            <th class="top-pages-v2-cpm-column"><button type="button" data-bind="event: {click: onReorderTableData.bind(this, $data, 'intervalCpm')}, css: {'i-sort-up': tableOrdering().col == 'intervalCpm' && tableOrdering().dir == 'ASC', 'i-sort-down': tableOrdering().col == 'intervalCpm' && tableOrdering().dir == 'DESC'}" class="top-pages-v2-sort icon i-sort" title="Last hour for this page. The smaller number is today for this page.">CPM</button></th>
                                        <!-- /ko -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <!-- ko foreach: topArticlesData -->
                                        <tr data-bind="event: { click: $parent.onClickRowClick.bind($data, $index(), $data)}, css: { 'is-selected': $parent.selectedRows().indexOf($index()) !== -1 }">
                                            <td class="top-pages-v2-number" data-bind="text: $index() + 1 + $parent.pageOffset()"></td>
                                            <td data-bind="text: $data.brand"></td>
                                            <!-- ko if: $parents[0].segmentsFilterException() -->
                                                <td data-bind="text: $data.segment"></td>
                                            <!-- /ko -->
                                            <!-- ko if: $parents[0].systemsFilterException() -->
                                                <td class="top-pages-v2-system" data-bind="text: $data.system"></td>
                                            <!-- /ko -->
                                            <td class="top-pages-v2-path">
                                                <a data-bind="event: { click: $parent.stopPropagation }, attr: {href: '/permalink_details?' + $parent.getEncodedViewModelParams() + '&brand=' + brand + '&permalink=' + permalinkUrl}"><span data-bind="text: $data.subdomain && $data.subdomain != 'www' ? ($data.subdomain + ' ... ' + $data.permalink) : $data.permalink"></span></a>
                                                <a class="icon i-ext-link" data-bind="event: { click: $parent.stopPropagation }, attr: {href: $data.permalinkUrl}" target="_blank" aria-label="Open page in a new tab"></a>
                                            </td>
                                            <!-- ko if: $parents[0].visitsViewsToggle() == 'visits' -->
                                                <td class="top-pages-v2-number top-pages-v2-group-boundary top-pages-v2-traffic-column top-pages-v2-visits-column"><div class="top-pages-v2-metric"><span class="top-pages-v2-value top-pages-v2-primary" data-bind="text: $data.visitCount"></span><span class="top-pages-v2-empty" aria-hidden="true"></span></div></td>
                                            <!-- /ko -->
                                            <!-- ko if: $parents[0].visitsViewsToggle() == 'views' -->
                                                <td class="top-pages-v2-number top-pages-v2-group-boundary top-pages-v2-traffic-column top-pages-v2-visits-column"><div class="top-pages-v2-metric"><span class="top-pages-v2-value top-pages-v2-primary" data-bind="text: $data.viewCount"></span><span class="top-pages-v2-empty" aria-hidden="true"></span></div></td>
                                            <!-- /ko -->
                                            <td class="top-pages-v2-number top-pages-v2-group-boundary top-pages-v2-engagement-column"><div class="top-pages-v2-metric"><span class="top-pages-v2-value" data-bind="text: $parent.formatNullablePercentage($parents[0].visitsViewsToggle() == 'visits' ? $data.engagedVisitPercentage : $data.engagedViewPercentage)"></span><span class="top-pages-v2-secondary" data-bind="text: Number($parents[0].visitsViewsToggle() == 'visits' ? ($data.engagedVisitCount || 0) : ($data.engagedViewCount || 0)).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></div></td>
                                            <!-- ko if: $parents[0].isMetricColumnVisible('engagedBreakdown') -->
                                                <td class="top-pages-v2-number top-pages-v2-engagement-column top-pages-v2-expanded-column top-pages-v2-expanded-column--start"><div class="top-pages-v2-metric top-pages-v2-metric--value-only"><span class="top-pages-v2-value" data-bind="text: $parent.formatNullablePercentage($parents[0].visitsViewsToggle() == 'visits' ? $data.engaged30SecondsVisitPercentage : $data.engaged30SecondsViewPercentage)"></span><span class="top-pages-v2-empty" aria-hidden="true"></span></div></td>
                                                <td class="top-pages-v2-number top-pages-v2-engagement-column top-pages-v2-expanded-column"><div class="top-pages-v2-metric top-pages-v2-metric--value-only"><span class="top-pages-v2-value" data-bind="text: $parent.formatNullablePercentage($parents[0].visitsViewsToggle() == 'visits' ? $data.engaged60SecondsVisitPercentage : $data.engaged60SecondsViewPercentage)"></span><span class="top-pages-v2-empty" aria-hidden="true"></span></div></td>
                                                <td class="top-pages-v2-number top-pages-v2-engagement-column top-pages-v2-expanded-column top-pages-v2-expanded-column--end"><div class="top-pages-v2-metric top-pages-v2-metric--value-only"><span class="top-pages-v2-value" data-bind="text: $parent.formatNullablePercentage($parents[0].visitsViewsToggle() == 'visits' ? $data.engaged90SecondsVisitPercentage : $data.engaged90SecondsViewPercentage)"></span><span class="top-pages-v2-empty" aria-hidden="true"></span></div></td>
                                            <!-- /ko -->
                                            <td class="top-pages-v2-number top-pages-v2-engagement-column top-pages-v2-interaction-ratio"><div class="top-pages-v2-metric"><span class="top-pages-v2-value" data-bind="text: $parent.formatInteractionRatio($parents[0].visitsViewsToggle() == 'visits' ? $data.interactionVisitRatio : $data.interactionViewRatio)"></span><span class="top-pages-v2-empty" aria-hidden="true"></span></div></td>
                                            <td class="top-pages-v2-number top-pages-v2-engagement-column"><div class="top-pages-v2-metric"><span class="top-pages-v2-value" data-bind="text: $parent.formatMinuteSeconds($data.avgTimeOnPageSeconds)"></span><span class="top-pages-v2-delta" data-bind="visible: $parent.hasTableDelta($data.avgTimeOnPageSecondsDelta), text: $parent.formatTableDelta($data.avgTimeOnPageSecondsDelta), css: {'increase': Math.round(Number($data.avgTimeOnPageSecondsDelta)) > 0, 'decrease': Math.round(Number($data.avgTimeOnPageSecondsDelta)) < 0, 'neutral': Math.round(Number($data.avgTimeOnPageSecondsDelta)) === 0}"></span></div></td>
                                            <!-- ko if: $parents[0].isMetricColumnVisible('avgViewEngagedSeconds') -->
                                                <td class="top-pages-v2-number top-pages-v2-engagement-column top-pages-v2-expanded-column top-pages-v2-expanded-column--start top-pages-v2-expanded-column--end"><div class="top-pages-v2-metric"><span class="top-pages-v2-value" data-bind="text: $parent.formatMinuteSeconds($data.avgViewEngagedSeconds)"></span><span class="top-pages-v2-delta" data-bind="visible: $parent.hasTableDelta($data.avgViewEngagedSecondsDelta), text: $parent.formatTableDelta($data.avgViewEngagedSecondsDelta), css: {'increase': Math.round(Number($data.avgViewEngagedSecondsDelta)) > 0, 'decrease': Math.round(Number($data.avgViewEngagedSecondsDelta)) < 0, 'neutral': Math.round(Number($data.avgViewEngagedSecondsDelta)) === 0}"></span></div></td>
                                            <!-- /ko -->
                                            <td class="top-pages-v2-number top-pages-v2-engagement-column top-pages-v2-depth-column"><div class="top-pages-v2-metric"><span class="top-pages-v2-value" data-bind="text: $parent.formatNullablePercentage($data.avgViewEngagedDepthPercentage)"></span><span class="top-pages-v2-delta" data-bind="visible: $parent.hasTableDelta($data.avgViewEngagedDepthPercentageDelta), text: $parent.formatTableDelta($data.avgViewEngagedDepthPercentageDelta), css: {'increase': Math.round(Number($data.avgViewEngagedDepthPercentageDelta)) > 0, 'decrease': Math.round(Number($data.avgViewEngagedDepthPercentageDelta)) < 0, 'neutral': Math.round(Number($data.avgViewEngagedDepthPercentageDelta)) === 0}"></span></div></td>
                                            <!-- ko if: $parents[0].usColumnException() && $parents[0].visitsViewsToggle() == 'visits' && ($parents[0].device() == 'desktop' || ($parents[0].device() == 'mobile' && $parents[0].deviceView() == 'desktop')) -->
                                                <td class="top-pages-v2-number top-pages-v2-group-boundary top-pages-v2-commercial-column top-pages-v2-us-column"><div class="top-pages-v2-metric"><span class="top-pages-v2-value" data-bind="text: $parent.formatNullablePercentage($data.usVisitPercentage)"></span><span class="top-pages-v2-delta" data-bind="visible: $parent.hasTableDelta($data.usVisitPercentageDelta), text: $parent.formatTableDelta($data.usVisitPercentageDelta), css: {'increase': Math.round(Number($data.usVisitPercentageDelta)) > 0, 'decrease': Math.round(Number($data.usVisitPercentageDelta)) < 0, 'neutral': Math.round(Number($data.usVisitPercentageDelta)) === 0}"></span></div></td>
                                            <!-- /ko -->
                                            <!-- ko if: $parents[0].usColumnException() && $parents[0].visitsViewsToggle() == 'views' && ($parents[0].device() == 'desktop' || ($parents[0].device() == 'mobile' && $parents[0].deviceView() == 'desktop')) -->
                                                <td class="top-pages-v2-number top-pages-v2-group-boundary top-pages-v2-commercial-column top-pages-v2-us-column"><div class="top-pages-v2-metric"><span class="top-pages-v2-value" data-bind="text: $parent.formatNullablePercentage($data.usViewPercentage)"></span><span class="top-pages-v2-delta" data-bind="visible: $parent.hasTableDelta($data.usViewPercentageDelta), text: $parent.formatTableDelta($data.usViewPercentageDelta), css: {'increase': Math.round(Number($data.usViewPercentageDelta)) > 0, 'decrease': Math.round(Number($data.usViewPercentageDelta)) < 0, 'neutral': Math.round(Number($data.usViewPercentageDelta)) === 0}"></span></div></td>
                                            <!-- /ko -->
                                            <!-- ko if: $parents[0].cpmColumnVisible() -->
                                                <td class="top-pages-v2-cpm-column"><div class="top-pages-v2-cpm"><span class="top-pages-v2-cpm-value" data-bind="text: $parent.formatCpm($data.intervalCpm)"></span><span class="top-pages-v2-cpm-day" data-bind="visible: $data.dayCpm !== null && $data.dayCpm !== '', text: $parent.formatDayCpm($data.dayCpm), attr: { title: 'Today' }"></span></div></td>
                                            <!-- /ko -->
                                        </tr>
                                    <!-- /ko -->
                                </tbody>
                            </table>
                            <table data-bind="visible: topArticlesData().length > 0, css: { 'is-expanded': isMetricColumnVisible('avgViewEngagedSeconds') }" class="list-results thin live-dashboard-table live-dashboard-top-pages-table">
                                <colgroup>
                                    <col class="table-column-rank">
                                    <col class="table-column-property">
                                    <!-- ko if: segmentsFilterException() -->
                                        <col class="table-column-context">
                                    <!-- /ko -->
                                    <!-- ko if: systemsFilterException() -->
                                        <col class="table-column-context">
                                    <!-- /ko -->
                                    <col class="table-column-page-path">
                                    <col class="table-column-metric">
                                    <col class="table-column-metric">
                                    <col class="table-column-metric">
                                    <!-- ko if: isMetricColumnVisible('avgViewEngagedSeconds') -->
                                        <col class="table-column-metric">
                                        <col class="table-column-metric">
                                        <col class="table-column-metric">
                                        <col class="table-column-metric">
                                    <!-- /ko -->
                                    <col class="table-column-metric">
                                    <col class="table-column-metric">
                                    <!-- ko if: usColumnException() && (device() == 'desktop' || (device() == 'mobile' && deviceView() == 'desktop')) -->
                                        <col class="table-column-metric">
                                    <!-- /ko -->
                                    <!-- ko if: cpmColumnVisible() -->
                                        <col class="table-column-metric">
                                    <!-- /ko -->
                                </colgroup>
                                <thead>
                                    <tr class="table-metric-parent-headers">
                                        <th colspan="2"></th>
                                        <!-- ko if: segmentsFilterException() -->
                                            <th></th>
                                        <!-- /ko -->
                                        <!-- ko if: systemsFilterException() -->
                                            <th></th>
                                        <!-- /ko -->
                                        <th></th>
                                        <th class="table-metric-parent-header table-metric-parent-header--traffic" scope="colgroup">Traffic</th>
                                        <th class="table-metric-parent-header table-metric-parent-header--engagement" scope="colgroup" data-bind="attr: { colspan: isMetricColumnVisible('avgViewEngagedSeconds') ? 8 : 4 }">
                                            <div class="table-metric-parent-header-content">
                                                <button class="table-metric-columns-toggle" type="button" data-bind="event: { click: toggleMetricColumn.bind($data, 'avgViewEngagedSeconds') }, css: { 'is-active': isMetricColumnVisible('avgViewEngagedSeconds') }, attr: { 'aria-expanded': isMetricColumnVisible('avgViewEngagedSeconds'), 'aria-label': isMetricColumnVisible('avgViewEngagedSeconds') ? 'Hide expanded engagement columns' : 'Show expanded engagement columns', title: isMetricColumnVisible('avgViewEngagedSeconds') ? 'Hide expanded engagement columns' : 'Show expanded engagement columns' }">
                                                    <span class="table-metric-parent-header-title">Engagement</span>
                                                    <span class="icon i-left"></span><span class="icon i-right"></span>
                                                </button>
                                            </div>
                                        </th>
                                        <!-- ko if: (usColumnException() && (device() == 'desktop' || (device() == 'mobile' && deviceView() == 'desktop'))) || cpmColumnVisible() -->
                                            <th class="table-metric-parent-header table-metric-parent-header--us" scope="colgroup" data-bind="attr: { colspan: ((usColumnException() && (device() == 'desktop' || (device() == 'mobile' && deviceView() == 'desktop'))) ? 1 : 0) + (cpmColumnVisible() ? 1 : 0) }">
                                                <div class="table-metric-parent-header-content">
                                                    <span>Marketability</span>
                                                </div>
                                            </th>
                                        <!-- /ko -->
                                    </tr>
                                    <tr>
                                        <th class="table-numeric">
                                            <span class=" icon list-sort-none">Rank</span>
                                        </th>
                                        <th>
                                            <span class=" icon list-sort-none">Property</span>
                                        </th>
                                        <!-- ko if: segmentsFilterException() -->
                                            <th>
                                                <span class="icon list-sort-none">Segment</span>
                                            </th>
                                        <!-- /ko -->
                                        <!-- ko if: systemsFilterException() -->
                                            <th>
                                                <span class="icon list-sort-none">System</span>
                                            </th>
                                        <!-- /ko -->
                                        <th>
                                            <span  data-bind="event: {click: onReorderTableData.bind(this, $data, 'permalink')}, css: {'i-sort-up': tableOrdering().col == 'permalink' && tableOrdering().dir == 'ASC', ' i-sort-down': tableOrdering().col == 'permalink' && tableOrdering().dir == 'DESC'}" class="icon i-sort">Page Path</span>
                                        </th>
                                        <!-- ko if: visitsViewsToggle() == 'visits' -->
                                            <th class="table-numeric table-metric-group-start table-metric-group-start--traffic">
                                                <span  data-bind="event: {click: onReorderTableData.bind(this, $data, 'visitCount')}, css: {'i-sort-up': tableOrdering().col == 'visitCount' && tableOrdering().dir == 'ASC', 'i-sort-down': tableOrdering().col == 'visitCount' && tableOrdering().dir == 'DESC'}" class="icon i-sort table-metric-group-title">Visits</span>
                                            </th>
                                        <!-- /ko -->
                                        <!-- ko if: visitsViewsToggle() == 'views' -->
                                            <th class="table-numeric table-metric-group-start table-metric-group-start--traffic">
                                                <span  data-bind="event: {click: onReorderTableData.bind(this, $data, 'viewCount')}, css: {'i-sort-up': tableOrdering().col == 'viewCount' && tableOrdering().dir == 'ASC', 'i-sort-down': tableOrdering().col == 'viewCount' && tableOrdering().dir == 'DESC'}" class="icon i-sort table-metric-group-title">Views</span>
                                            </th>
                                        <!-- /ko -->
                                        <!-- Engaged Visits / Engaged Views: UUID-deduplicated count; name follows the metric toggle. -->
                                        <th class="table-numeric table-metric-group-start table-metric-group-start--engagement table-metric-group-end table-metric-tooltip-header">
                                            <div data-bind="event: {click: onReorderTableData.bind(this, $data, getEngagedOrderColumn())}, css: {'i-sort-up': tableOrdering().col == getEngagedOrderColumn() && tableOrdering().dir == 'ASC', 'i-sort-down': tableOrdering().col == getEngagedOrderColumn() && tableOrdering().dir == 'DESC'}"><span class="icon i-sort table-metric-group-title" data-bind="text: visitsViewsToggle() == 'visits' ? 'Eng. Visits' : 'Eng. Views'"></span></div>
                                            <div class="w-tooltips-adv auto-height short pos-right-tight in-list engagement-tooltip" data-bind="template: { name: 'infoButton-template', data: getEngagedPagesTooltip().getTemplateViewModel() }"></div>
                                        </th>
                                        <th class="table-numeric table-metric-group--engagement table-metric-tooltip-header">
                                            <div data-bind="event: {click: onReorderTableData.bind(this, $data, 'interactionRatio')}, css: {'i-sort-up': tableOrdering().col == 'interactionRatio' && tableOrdering().dir == 'ASC', 'i-sort-down': tableOrdering().col == 'interactionRatio' && tableOrdering().dir == 'DESC'}"><span class="icon i-sort">Interaction Ratio</span></div>
                                            <div class="w-tooltips-adv auto-height short pos-right-tight in-list engagement-tooltip" data-bind="template: { name: 'infoButton-template', data: getInteractionRatioTooltip().getTemplateViewModel() }"></div>
                                        </th>
                                        <!-- ko if: isMetricColumnVisible('avgViewEngagedSeconds') -->
                                            <th class="table-numeric table-metric-group--engagement">
                                                <span data-bind="event: {click: onReorderTableData.bind(this, $data, 'avgViewEngagedSeconds')}, css: {'i-sort-up': tableOrdering().col == 'avgViewEngagedSeconds' && tableOrdering().dir == 'ASC', 'i-sort-down': tableOrdering().col == 'avgViewEngagedSeconds' && tableOrdering().dir == 'DESC'}" class="icon i-sort">AVD</span>
                                            </th>
                                            <th class="table-numeric table-metric-group--engagement"><span class="top-pages-v2-duration-label">30s+</span></th>
                                            <th class="table-numeric table-metric-group--engagement"><span class="top-pages-v2-duration-label">60s+</span></th>
                                            <th class="table-numeric table-metric-group--engagement"><span class="top-pages-v2-duration-label">90s+</span></th>
                                        <!-- /ko -->
                                        <th class="table-numeric table-metric-group--engagement table-metric-tooltip-header">
                                            <div data-bind="event: {click: onReorderTableData.bind(this, $data, 'avgTimeOnPageSeconds')}, css: {'i-sort-up': tableOrdering().col == 'avgTimeOnPageSeconds' && tableOrdering().dir == 'ASC', 'i-sort-down': tableOrdering().col == 'avgTimeOnPageSeconds' && tableOrdering().dir == 'DESC'}"><span class="icon i-sort">TᴏP</span></div>
                                            <div class="w-tooltips-adv auto-height short pos-right-tight in-list engagement-tooltip" data-bind="template: { name: 'infoButton-template', data: getTimeOnPageTooltip().getTemplateViewModel() }"></div>
                                        </th>
                                        <th class="table-numeric table-metric-group--engagement">
                                            <span data-bind="event: {click: onReorderTableData.bind(this, $data, 'avgViewEngagedDepthPercentage')}, css: {'i-sort-up': tableOrdering().col == 'avgViewEngagedDepthPercentage' && tableOrdering().dir == 'ASC', 'i-sort-down': tableOrdering().col == 'avgViewEngagedDepthPercentage' && tableOrdering().dir == 'DESC'}" class="icon i-sort">Scroll Depth %</span>
                                        </th>
                                        <!-- ko if: usColumnException() && visitsViewsToggle() == 'visits' && (device() == 'desktop' || (device() == 'mobile' && deviceView() == 'desktop'))-->
                                            <th class="table-numeric table-metric-group-start table-metric-group-start--us">
                                                <span  data-bind="event: {click: onReorderTableData.bind(this, $data, 'usVisitPercentage')}, css: {'i-sort-up': tableOrdering().col == 'usVisitPercentage' && tableOrdering().dir == 'ASC', 'i-sort-down': tableOrdering().col == 'usVisitPercentage' && tableOrdering().dir == 'DESC'}" class="icon i-sort table-metric-group-title">US %</span>
                                            </th>
                                        <!-- /ko -->
                                        <!-- ko if: usColumnException() && visitsViewsToggle() == 'views' && (device() == 'desktop' || (device() == 'mobile' && deviceView() == 'desktop'))-->
                                            <th class="table-numeric table-metric-group-start table-metric-group-start--us">
                                                <span  data-bind="event: {click: onReorderTableData.bind(this, $data, 'usViewPercentage')}, css: {'i-sort-up': tableOrdering().col == 'usViewPercentage' && tableOrdering().dir == 'ASC', 'i-sort-down': tableOrdering().col == 'usViewPercentage' && tableOrdering().dir == 'DESC'}" class="icon i-sort table-metric-group-title">US %</span>
                                            </th>
                                        <!-- /ko -->
                                        <!-- ko if: cpmColumnVisible() -->
                                            <th class="table-numeric">
                                                <span data-bind="event: {click: onReorderTableData.bind(this, $data, 'intervalCpm')}, css: {'i-sort-up': tableOrdering().col == 'intervalCpm' && tableOrdering().dir == 'ASC', 'i-sort-down': tableOrdering().col == 'intervalCpm' && tableOrdering().dir == 'DESC'}" class="icon i-sort" title="Last hour for this page. The smaller number is today for this page.">CPM</span>
                                            </th>
                                        <!-- /ko -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <!-- ko foreach: topArticlesData -->
                                        <tr data-bind="event: { click: $parent.onClickRowClick.bind($data, $index(), $data)}, style: { 'background-color': $parent.selectedRows().indexOf($index()) !== -1 ? '#dbdbed' : '' }">
                                            <td class="table-numeric">
                                                <span data-bind="text: $index() + 1 + $parent.pageOffset()"></span>
                                            </td>
                                            <td>
                                                <span data-bind="text: $data.brand"></span>
                                            </td>
                                            <!-- ko if: $parents[0].segmentsFilterException() -->
                                                <td >
                                                    <span data-bind="text: $data.segment"></span>
                                                </td>
                                            <!-- /ko -->
                                            <!-- ko if: $parents[0].systemsFilterException() -->
                                                <td >
                                                    <span data-bind="text: $data.system"></span>
                                                </td>
                                            <!-- /ko -->
                                            <td>
                                                <a data-bind="event: { click: $parent.stopPropagation }, attr: {href: '/permalink_details?' + $parent.getEncodedViewModelParams() + '&brand=' + brand + '&permalink=' + permalinkUrl}">
                                                    <span class="ios-font-fix" data-bind="text: $data.subdomain && $data.subdomain != 'www' ? ($data.subdomain + ' ... ' + $data.permalink) : $data.permalink"></span>
                                                </a>
                                                <a class="icon i-ext-link" data-bind="event: { click: $parent.stopPropagation }, attr: {href: $data.permalinkUrl}" target="_blank"></a>
                                            </td>
                                            <!-- ko if: $parents[0].visitsViewsToggle() == 'visits' -->
                                                <td class="table-numeric table-metric-group-start table-metric-group-start--traffic">
                                                    <span class="table-metric-value" data-bind="text: $data.visitCount"></span>
                                                </td>
                                            <!-- /ko -->
                                            <!-- ko if: $parents[0].visitsViewsToggle() == 'views' -->
                                                <td class="table-numeric table-metric-group-start table-metric-group-start--traffic">
                                                    <span class="table-metric-value" data-bind="text: $data.viewCount"></span>
                                                </td>
                                            <!-- /ko -->
                                            <td class="table-numeric table-metric-group-start table-metric-group-start--engagement table-metric-group-end">
                                                <div class="table-metric-cell">
                                                    <span class="table-metric-value" data-bind="text: $parent.formatNullablePercentage($parents[0].visitsViewsToggle() == 'visits' ? $data.engagedVisitPercentage : $data.engagedViewPercentage)"></span>
                                                    <span class="table-metric-suffix" data-bind="text: Number($parents[0].visitsViewsToggle() == 'visits' ? ($data.engagedVisitCount || 0) : ($data.engagedViewCount || 0)).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                </div>
                                            </td>
                                            <td class="table-numeric table-metric-group--engagement">
                                                <div class="table-metric-cell table-metric-cell--value-only">
                                                    <span class="table-metric-value" data-bind="text: $parent.formatInteractionRatio($parents[0].visitsViewsToggle() == 'visits' ? $data.interactionVisitRatio : $data.interactionViewRatio)"></span>
                                                    <span class="table-metric-placeholder" aria-hidden="true"></span>
                                                </div>
                                            </td>
                                            <!-- ko if: $parents[0].isMetricColumnVisible('avgViewEngagedSeconds') -->
                                                <td class="table-numeric table-metric-group--engagement">
                                                    <div class="table-metric-cell">
                                                        <span class="table-metric-value" data-bind="text: $parent.formatMinuteSeconds($data.avgViewEngagedSeconds)"></span>
                                                        <span class="table-metric-delta delta" data-bind="visible: $parent.hasTableDelta($data.avgViewEngagedSecondsDelta), text: $parent.formatTableDelta($data.avgViewEngagedSecondsDelta), css: {'increase': Math.round(Number($data.avgViewEngagedSecondsDelta)) > 0, 'decrease': Math.round(Number($data.avgViewEngagedSecondsDelta)) < 0, 'neutral': Math.round(Number($data.avgViewEngagedSecondsDelta)) === 0}"></span>
                                                    </div>
                                                </td>
                                                <td class="table-numeric table-metric-group--engagement"><div class="table-metric-cell table-metric-cell--value-only"><span class="table-metric-value" data-bind="text: $parent.formatNullablePercentage($parents[0].visitsViewsToggle() == 'visits' ? $data.engaged30SecondsVisitPercentage : $data.engaged30SecondsViewPercentage)"></span></div></td>
                                                <td class="table-numeric table-metric-group--engagement"><div class="table-metric-cell table-metric-cell--value-only"><span class="table-metric-value" data-bind="text: $parent.formatNullablePercentage($parents[0].visitsViewsToggle() == 'visits' ? $data.engaged60SecondsVisitPercentage : $data.engaged60SecondsViewPercentage)"></span></div></td>
                                                <td class="table-numeric table-metric-group--engagement"><div class="table-metric-cell table-metric-cell--value-only"><span class="table-metric-value" data-bind="text: $parent.formatNullablePercentage($parents[0].visitsViewsToggle() == 'visits' ? $data.engaged90SecondsVisitPercentage : $data.engaged90SecondsViewPercentage)"></span></div></td>
                                            <!-- /ko -->
                                            <td class="table-numeric table-metric-group--engagement">
                                                <div class="table-metric-cell">
                                                    <span class="table-metric-value" data-bind="text: $parent.formatMinuteSeconds($data.avgTimeOnPageSeconds)"></span>
                                                    <span class="table-metric-delta delta" data-bind="visible: $parent.hasTableDelta($data.avgTimeOnPageSecondsDelta), text: $parent.formatTableDelta($data.avgTimeOnPageSecondsDelta), css: {'increase': Math.round(Number($data.avgTimeOnPageSecondsDelta)) > 0, 'decrease': Math.round(Number($data.avgTimeOnPageSecondsDelta)) < 0, 'neutral': Math.round(Number($data.avgTimeOnPageSecondsDelta)) === 0}"></span>
                                                </div>
                                            </td>
                                            <td class="table-numeric table-metric-group--engagement">
                                                <div class="table-metric-cell">
                                                    <span class="table-metric-value" data-bind="text: $parent.formatNullablePercentage($data.avgViewEngagedDepthPercentage)"></span>
                                                    <span class="table-metric-delta delta" data-bind="visible: $parent.hasTableDelta($data.avgViewEngagedDepthPercentageDelta), text: $parent.formatTableDelta($data.avgViewEngagedDepthPercentageDelta), css: {'increase': Math.round(Number($data.avgViewEngagedDepthPercentageDelta)) > 0, 'decrease': Math.round(Number($data.avgViewEngagedDepthPercentageDelta)) < 0, 'neutral': Math.round(Number($data.avgViewEngagedDepthPercentageDelta)) === 0}"></span>
                                                </div>
                                            </td>
                                            <!-- ko if: $parents[0].usColumnException() && $parents[0].visitsViewsToggle() == 'visits' && ($parents[0].device() == 'desktop' || ($parents[0].device() == 'mobile' && $parents[0].deviceView() == 'desktop'))-->
                                                <td class="table-numeric table-metric-group-start table-metric-group-start--us">
                                                    <div class="table-metric-cell">
                                                        <span class="table-metric-value" data-bind="text: $parent.formatNullablePercentage($data.usVisitPercentage)"></span>
                                                        <span class="table-metric-delta delta" data-bind="visible: $parent.hasTableDelta($data.usVisitPercentageDelta), text: $parent.formatTableDelta($data.usVisitPercentageDelta), css: {'increase': Math.round(Number($data.usVisitPercentageDelta)) > 0, 'decrease': Math.round(Number($data.usVisitPercentageDelta)) < 0, 'neutral': Math.round(Number($data.usVisitPercentageDelta)) === 0}"></span>
                                                    </div>
                                                </td>
                                            <!-- /ko -->
                                            <!-- ko if: $parents[0].usColumnException() && $parents[0].visitsViewsToggle() == 'views' && ($parents[0].device() == 'desktop' || ($parents[0].device() == 'mobile' && $parents[0].deviceView() == 'desktop'))-->
                                                <td class="table-numeric table-metric-group-start table-metric-group-start--us">
                                                    <div class="table-metric-cell">
                                                        <span class="table-metric-value" data-bind="text: $parent.formatNullablePercentage($data.usViewPercentage)"></span>
                                                        <span class="table-metric-delta delta" data-bind="visible: $parent.hasTableDelta($data.usViewPercentageDelta), text: $parent.formatTableDelta($data.usViewPercentageDelta), css: {'increase': Math.round(Number($data.usViewPercentageDelta)) > 0, 'decrease': Math.round(Number($data.usViewPercentageDelta)) < 0, 'neutral': Math.round(Number($data.usViewPercentageDelta)) === 0}"></span>
                                                    </div>
                                                </td>
                                            <!-- /ko -->
                                            <!-- ko if: $parents[0].cpmColumnVisible() -->
                                                <td class="table-numeric">
                                                    <div class="table-metric-cell">
                                                        <span class="table-metric-value" data-bind="text: $parent.formatCpm($data.intervalCpm)"></span>
                                                        <span class="table-metric-suffix" data-bind="visible: $data.dayCpm !== null && $data.dayCpm !== '', text: $parent.formatDayCpm($data.dayCpm), attr: { title: 'Today' }"></span>
                                                    </div>
                                                </td>
                                            <!-- /ko -->
                                        </tr>
                                    <!-- /ko -->
                                </tbody>
                            </table>
                        </div>
                    </div>
                <!-- /ko -->
            </div>

            <footer class="default-footer">
                <span class="logo-short"></span>
                <span class="footer-text">©${new Date().getFullYear()} ValServ Inc. All rights reserved.</span>
                <span>|</span>
                <a href="https://sentinelpro.com/pages/privacy-policy" target="_blank">Privacy Policy</a>
            </footer>
        `;
    }

    /**
     * @inheritDoc
     */
    protected initPartial(): void {

        this.presetFilter = new presetFilter_template("presetFilter", this.getTemplateViewModel(), this.caller);
        this.presetFilter.setType('liveDashboard');

        this.pagination = new pagination_template('pagination', this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 50;

        this.brandFilter = new filterSingle_multiLevel_selector_template('brandFilter', this.getTemplateViewModel(), this.caller);
        this.brandFilter.setLabel("Property");
        this.brandFilter.setAllOptionsText("Network");

        this.brandFilter.setHasLogo(true);
        this.brandFilter.setDefaultLogo(vnApp_sentinelbi.BRAND_DEFAULT_ICON_PATH);

        window.addEventListener('click', event => {
            const topPagesBrandFilter = document.getElementById('top-pages-brand-filter');

            if (!topPagesBrandFilter?.contains(event.target as Node)) {
                this.getTemplateViewModel().isTopPagesBrandFilterOpen(false);
            }
        });

        this.viewModeFilter = new filterDropdown_template('viewModeFilter', this.getTemplateViewModel(), this.caller);

        this.multiSegmentsFilter = new multipleSelector_template("multiSegmentsFilter", this.getTemplateViewModel(), this.caller);
        this.multiSegmentsFilter.setLabel("Segments");
        this.multiSegmentsFilter.setTagContainerId('selected-segments');
        this.multiSegmentsFilter.setTagContainerCaption('Selected segments:');

        this.segmentsFilter = new filterDropdown_template('segmentsFilter', this.getTemplateViewModel(), this.caller);

        // Get the current date
        const currentDate = new Date();

        // Get the date for yesterday
        const yesterday = new Date(currentDate);
        yesterday.setDate(currentDate.getDate() - 1);

        // Get the date 7 days before yesterday
        const lastWeekStart = new Date(yesterday);
        lastWeekStart.setDate(yesterday.getDate() - 7);

        // Get the date 7 days before last week start
        const weekBeforeLastStart = new Date(lastWeekStart);
        weekBeforeLastStart.setDate(lastWeekStart.getDate() - 7);

        this.dateRangeFilter = new filterDate_template("dateRangeFilter", this.getTemplateViewModel(), this.caller);
        this.dateRangeFilter.setStartPickerId('dateRangeStartDatePicker');
        this.dateRangeFilter.setEndPickerId('dateRangeEndDatePicker');
        this.dateRangeFilter.setDateRange(lastWeekStart, yesterday);

        this.compRangeFilter = new filterDate_template("compRangeFilter", this.getTemplateViewModel(), this.caller);
        this.compRangeFilter.setLabel('Comparison Date Range');
        this.compRangeFilter.setStartPickerId('compRangeStartDatePicker');
        this.compRangeFilter.setEndPickerId('compRangeEndDatePicker');
        this.compRangeFilter.setDateRange(weekBeforeLastStart, lastWeekStart);

        this.indicatorsChart = new amCharts_v4_date_basic_template('indicatorsChart', this.getTemplateViewModel(), this.caller);
        this.pingDiffIndicatorsChart = new amCharts_v4_date_basic_template('pingDiffIndicatorsChart', this.getTemplateViewModel(), this.caller);
        this.pingAvgLoadIndicatorsChart = new amCharts_v4_date_basic_template('pingAvgLoadIndicatorsChart', this.getTemplateViewModel(), this.caller);

        this.usViewsDonutChart = new amCharts_v4_category_donut_template("usViewsDonutChart", this.getTemplateViewModel(), this.caller);
        this.usViewsDonutChart.setXAxisRotation(-90);
        this.usViewsDonutChart.setXAxisFontSize(14);

        this.androidViewsDonutChart = new amCharts_v4_category_donut_template("androidViewsDonutChart", this.getTemplateViewModel(), this.caller);
        this.androidViewsDonutChart.setXAxisRotation(-90);
        this.androidViewsDonutChart.setXAxisFontSize(14);

        this.reportStatusTooltip = new infoButton_template('pingGraphTooltip', this.getTemplateViewModel(), this.caller);

        let pingGraphTooltipContent = `
            <p>Displays how often the Sentinel Ping system detected page load interruptions. Higher percentages may indicate JavaScript errors that prevent parts of the page from loading correctly.</p>`;
        this.pingGraphTooltip = new infoButton_template('pingGraphTooltip', this.getTemplateViewModel(), this.caller)
        // this.pingGraphTooltip.setTitle('Ping');
        this.pingGraphTooltip.setContent(pingGraphTooltipContent);

        let sourcesTooltipContent = `
            <p>Displays data from the past five minutes, with referring domains grouped for clarity.</p>`;
        this.sourcesTooltip = new infoButton_template('sourcesTooltip', this.getTemplateViewModel(), this.caller)
        this.sourcesTooltip.setContent(sourcesTooltipContent);

        let devicesTooltipContent = `
            <p>Displays data from the past five minutes, organized by device and operating system type.</p>`;
        this.devicesTooltip = new infoButton_template('devicesTooltip', this.getTemplateViewModel(), this.caller)
        this.devicesTooltip.setContent(devicesTooltipContent);

        let geoTooltipContent = `
            <p>Displays data from the past five minutes, categorized by country.</p>`;
        this.geoTooltip = new infoButton_template('geoTooltip', this.getTemplateViewModel(), this.caller)
        this.geoTooltip.setContent(geoTooltipContent);

        let pingAvgLoadGraphTooltipContent = `
            <p>Shows the time between the Sentinel Ping events at the top and bottom of the page. An increase may indicate something is slowing down page execution in the browser.</p>`;
        this.pingAvgLoadGraphTooltip = new infoButton_template('pingAvgLoadGraphTooltip', this.getTemplateViewModel(), this.caller)
        // this.pingAvgLoadGraphTooltip.setTitle('Avg Load Time');
        this.pingAvgLoadGraphTooltip.setContent(pingAvgLoadGraphTooltipContent);

        let engagedPagesTooltipContent = `
            <div class="table-metric-tooltip-content">
                <ol class="table-metric-tooltip-ordered-list">
                    <li>% of visits or views that engaged.</li>
                    <li>Engaged = any of:
                        <ul class="table-metric-tooltip-list">
                            <li><b class="engagement-tooltip-number">30s+</b> total active time on page.</li>
                            <li>Clicks to another page, then reads it for <b class="engagement-tooltip-number">30s+</b>.</li>
                            <li>Scrolls <b class="engagement-tooltip-number">50%+</b> and takes an action (subscribe, log in, follow, like, comment, vote).</li>
                        </ul>
                    </li>
                    <li>Active time includes the initial read and time after returning to the tab. Idle and hidden-tab time are excluded.</li>
                </ol>
            </div>`;
        this.engagedPagesTooltip = new infoButton_template('engagedPagesTooltip', this.getTemplateViewModel(), this.caller);
        this.engagedPagesTooltip.setTitle('Engaged Visits/Views %');
        this.engagedPagesTooltip.setContent(engagedPagesTooltipContent);

        this.engagedBreakdownTooltips = {};
        ['30s', '60s', '90s'].forEach(duration => {
            const tooltip = new infoButton_template('engagedBreakdown' + duration + 'Tooltip', this.getTemplateViewModel(), this.caller);
            tooltip.setTitle('Engaged breakdown');
            tooltip.setContent('<p class="table-metric-tooltip-lead">% of visits or views reaching ' + duration + ' of total active time.</p>');
            this.engagedBreakdownTooltips[duration] = tooltip;
        });

        const avgViewDurationTooltipContent = `
            <div class="table-metric-tooltip-content">
                <ul class="table-metric-tooltip-list">
                    <li>Average active time, first read only.</li>
                    <li>Stops when the reader leaves the tab.</li>
                </ul>
            </div>`;
        const segmentSystemTooltipContent = `
            <div class="table-metric-tooltip-content">
                <ul class="table-metric-tooltip-list">
                    <li>% difference vs the average article in the same segment and system.</li>
                    <li><strong>+20%</strong> = 20% above.</li>
                </ul>
            </div>`;
        this.avgViewDurationTooltip = new infoButton_template('avgViewDurationTooltip', this.getTemplateViewModel(), this.caller);
        this.avgViewDurationTooltip.setTitle('AVD');
        this.avgViewDurationTooltip.setContent(avgViewDurationTooltipContent);

        let timeOnPageTooltipContent = `
            <div class="table-metric-tooltip-content">
                <ul class="table-metric-tooltip-list">
                    <li>Average active time on page.</li>
                    <li>Includes time after returning to the tab.</li>
                    <li>Idle time excluded.</li>
                </ul>
            </div>`;
        this.timeOnPageTooltip = new infoButton_template('timeOnPageTooltip', this.getTemplateViewModel(), this.caller);
        this.timeOnPageTooltip.setTitle('ToP (Time on Page)');
        this.timeOnPageTooltip.setContent(timeOnPageTooltipContent);

        let interactionRatioTooltipContent = `
            <div class="table-metric-tooltip-content">
                <ul class="table-metric-tooltip-list">
                    <li>Weighted interactions as a % of views.</li>
                    <li><strong>5:</strong> Affiliate carousel</li>
                    <li><strong>4:</strong> Login, registration, threads, author &amp; profile pages, Discord</li>
                    <li><strong>3:</strong> Videos, games, maps, tools, quick-action sidebar, TCG DB</li>
                    <li><strong>2:</strong> Filters, game ticker, social bar, YouTube header</li>
                    <li><strong>1:</strong> Header, sidebar, action bar, widgets, DB search, internal clicks</li>
                    <li><strong>0:</strong> Image galleries, external links, featured/tag cards</li>
                </ul>
            </div>`;
        this.interactionRatioTooltip = new infoButton_template('interactionRatioTooltip', this.getTemplateViewModel(), this.caller);
        this.interactionRatioTooltip.setTitle('IR (Interaction Ratio)');
        this.interactionRatioTooltip.setContent(interactionRatioTooltipContent);

        this.comparisonFilter = new filterSingle_multiLevel_selector_template('comparisonFilter', this.getTemplateViewModel(), this.caller);
        this.comparisonFilter.setLabel('Comparison');

        this.metricFilter = new filterSingle_multiLevel_selector_template('metricFilter', this.getTemplateViewModel(), this.caller);
        this.metricFilter.setLabel('Metric');

        this.intervalFilter = new filterSingle_multiLevel_selector_template('intervalFilter', this.getTemplateViewModel(), this.caller);
        this.intervalFilter.setLabel('Interval');

        this.relativePerformanceTooltip = new infoButton_template('relativePerformanceTooltip', this.getTemplateViewModel(), this.caller);
        this.relativePerformanceTooltip.setTitle('Seg/System');
        this.relativePerformanceTooltip.setContent(segmentSystemTooltipContent);

        this.deltaFilter = new filterSingle_multiLevel_selector_template('deltaFilter', this.getTemplateViewModel(), this.caller);
        this.deltaFilter.setLabel('Relative Performance');

        window.addEventListener('click', event => {

            const metrics = document.querySelector('.side-block-filters');
            const metricsButton = document.querySelector('.mobile-filters');
            const filters = document.querySelector('.sidebar-default-right');
            const filtersButtons = document.querySelectorAll('.filterToggle-btn');

            // sidebar button + menu
            const sidebar = document.querySelectorAll('.js-sidebar');
            const sidebarMobile = document.querySelector('.i-preferences');

            if(!metrics?.contains(event.target as Element) && !metricsButton?.contains(event.target as Element)){

                this.getTemplateViewModel().isMetricsOpen(false);
            }

            if(!filters?.contains(event.target as Element) && !filtersButtons[0]?.contains(event.target as Element) && !filtersButtons[1]?.contains(event.target as Element) && !(event.target as Element).closest('.form-auto-item') && !(event.target as Element).closest('.btn-f-s')){

                this.getTemplateViewModel().isFiltersOpen(false);
            }

            if(!sidebar[0]?.contains(event.target as Element) && !sidebar[1]?.contains(event.target as Element) && !sidebarMobile?.contains(event.target as Element)){

                this.getTemplateViewModel().sidebarToggle(false);
            }
        })

        this.annotationTooltip = new infoButton_template('annotationTooltip', this.getTemplateViewModel(), this.caller)
        this.annotationTooltip.setContent('');
    }

    /**
     * @inheritDoc
     */
    protected getTemplateName(): string{

        return 'liveDashboard_template';
    }

    /**
     * @inheritDoc
     */
    public buildViewModel(): Object{

        let self = this;

        return {

            reportStatusData: ko.observable(),
            sampledDatesData: ko.observableArray([]),
            clientTimezone: ko.observable(null),
            deviceView: ko.observable('mobile'),
            device: ko.observable('desktop'),
            selectedBrand: ko.observable("all"),
            comparisonSwitch: ko.observable("lastWeek"),
            visitsViewsToggle: ko.observable('visits'),
            totalsData: ko.observableArray([]),
            topArticlesData: ko.observableArray([]),
            tableDimensionsData: ko.observableArray([]),
            showTableDimensions: ko.observable(false),
            indicatorsBreakdownData: ko.observableArray([]),
            indicatorsBreakdownLength: ko.observable(0),
            segmentsData: ko.observableArray([]),
            indicatorsChartObj: ko.observable(null),
            indicatorsDateRange: ko.observableArray([]),
            collapsibleFilters: ko.observable({}),
            indicatorsDateRangeDataLength: ko.observable(0),
            indicatorsCompDateRange: ko.observableArray([]),
            indicatorsCompDateRangeDataLength: ko.observable(0),
            timelineAnnotationsData: ko.observableArray([]),
            selectedRows: ko.observable([]),
            pingAvgLoadIndicatorsDateRange: ko.observableArray([]),
            pingDiffIndicatorsDateRange: ko.observableArray([]),
            isFiltersOpen: ko.observable(false),
            isMetricsOpen: ko.observable(false),
            isTopStatsOpen: ko.observable(false),
            snapshotDateTime: ko.observable(null),
            dynamicFiltersData: ko.observableArray([]),
            reportWidgetColumnLayout: ko.observableArray([]),
            reportWidgetData: ko.observableArray(),
            segmentsFilterException: ko.observable(false),
            systemsFilterException: ko.observable(false),
            usColumnException: ko.observable(false),
            botToggleButtonException: ko.observable(false),
            deltaToggleButtonException: ko.observable(false),
            cpmColumnVisible: ko.observable(false),
            deltaToggleButtonInitialized: ko.observable(false),
            dynamicFilters: ko.observableArray([]),
            dynamicFiltersGroupedByName: ko.observableArray([]),
            dynamicFiltersGrouped: ko.observableArray([]),
            customDimensionsNames: ko.observableArray([]),
            sidebarToggle: ko.observable(false),
            isBotMode: ko.observable(false),
            deltaMode: ko.observable('filterAverage'),
            dimensionGroupSwitch: ko.observable('time'),
            pageOffset: ko.observable(0),
            tableOrdering: ko.observable({ col: null, dir: null }),
            collapsibleMetricColumns: ko.observable({
                avgViewEngagedSeconds: false,
                engagedBreakdown: false
            }),
            isTopPagesBrandFilterOpen: ko.observable(false),
            sequentialBrands: ko.observableArray([]),
            defaultDimensionColorClass: ko.observable({
                "Referrer" : 'referrer',
                "Device" : 'device',
                "Operating System": 'os',
                "Geo" : 'geo',
                "Login Status": 'login-status',
                "Browser":  'browser',
                "Plans":  'plans',
                "Ad Block":  'ad-block'
            }),
            onCycleBrand: function(data, isPrevious){

                return self.onCycleBrand(isPrevious);
            },
            toggleTopPagesBrandFilter: function(){

                return self.toggleTopPagesBrandFilter();
            },
            onTopPagesBrandOptionChange: function(item: any){

                return self.onTopPagesBrandOptionChange(item);
            },
            getDimensionNiceName: function(){

                return self.getDimensionNiceName();
            },
            onReorderTableData: function(data, column){

                self.reorderTableData(data, column)
            },

            isMetricColumnVisible: function(column){

                return self.isMetricColumnVisible(column);
            },

            toggleMetricColumn: function(column){

                self.toggleMetricColumn(column);
            },

            onMouseOverPreset : function () {

                self.onMouseOverPreset();
            },
            onMouseOutPreset : function () {

                self.onMouseOutPreset();
            },

            getPercentOfTotal: function(data) {

                return self.getPercentOfTotal(data);
            },

            onDimensionGroupSwitch: function(data, event) {

                self.onDimensionGroupSwitch(data, event);
            },

            showMoreTopStats: function(data){
                self.showMoreTopStats();
            },

            toggleOpenFilters: function(data){

                self.toggleOpenFilters();
            },

            toggleOpenMetrics: function(data){

                self.toggleOpenMetrics();
            },

            onBrandSelection: function(brandId){

                self.onBrandSelection(brandId);
            },
            onClickRowClick: function(index, data){

                self.onClickRowClick(index);
            },
            stopPropagation: function(data, event){

                self.stopPropagation(event);
                return true;
            },
            getMainDashTooltip: function(data) {

                return self.getMainDashTooltip();
            },
            getEngagedPagesTooltip: function(data) {

                return self.getEngagedPagesTooltip();
            },
            getEngagedBreakdownTooltip: function(duration) {

                return self.getEngagedBreakdownTooltip(duration);
            },
            getAvgViewDurationTooltip: function() {

                return self.getAvgViewDurationTooltip();
            },
            getEngagedOrderColumn: function(){

                return self.getEngagedOrderColumn();
            },
            getRelativePerformanceTooltip: function() {

                return self.getRelativePerformanceTooltip();
            },
            getTimeOnPageTooltip: function() {

                return self.getTimeOnPageTooltip();
            },
            getInteractionRatioTooltip: function() {

                return self.getInteractionRatioTooltip();
            },
            getNiceIntervalName: function(){

                return self.getNiceIntervalName();
            },
            clearSnapshot: function(){

                return self.clearSnapshot();
            },
            widgetNoData: function(data, type){

                return self.widgetNoData(type);
            },
            toggleWidgetFilter: function(data, filterId){

                return self.toggleWidgetFilter(data, filterId);
            },
            isWidgetItemSelected: function(data, filterId){

                return self.isWidgetItemSelected(data, filterId);
            },
            onSidebarToggle: function(data){

                return self.onSidebarToggle();
            },
            getWidgetDataByKey: function(key, data){

                return self.getWidgetDataByKey(key);
            },
            getWidgetGraphHtml: function(widgetType, widgetName, data){

                return self.getWidgetGraphHtml(widgetType, widgetName);
            }
            ,
            toggleBotMode: function(){

                return self.toggleBotMode();
            },
            getEncodedViewModelParams: function(){

                return self.getEncodedViewModelParams();
            },
            formatMinuteSeconds: function(value){
                return self.formatMinuteSeconds(value);
            },
            formatNullablePercentage: function(value){
                return self.formatNullablePercentage(value);
            },
            formatCpm: function(value){
                return self.formatCpm(value);
            },
            formatDayCpm: function(value){
                return self.formatDayCpm(value);
            },
            formatInteractionRatio: function(value: any){
                return self.formatInteractionRatio(value);
            },
            hasTableDelta: function(value){
                return self.hasTableDelta(value);
            },
            formatTableDelta: function(value){
                return self.formatTableDelta(value);
            },
        };
    }

    // if previous set to false, it means we take the next instead.
    public onCycleBrand(isPrevious: boolean) {

        const sequentialBrands = this.getTemplateViewModel().sequentialBrands();
        const selectedOption = this.brandFilter.getSelectedOption();

        if (sequentialBrands.length == 0 || !sequentialBrands) {
            return;
        }

        let newIndex = 0;

        if(selectedOption == 'all'){

            newIndex = isPrevious ? sequentialBrands.length - 1 : 0;
        } else if(selectedOption.includes('portfolio_')) {

            for(let i = 0; i < sequentialBrands.length; i++){

                if(sequentialBrands[i].portfolioId == selectedOption){

                    newIndex = isPrevious ? i - 1 : i;
                    break;
                }
            }
        } else if(selectedOption.includes('brand_')) {

            for(let i = 0; i < sequentialBrands.length; i++){

                if(sequentialBrands[i].brandItem.id == selectedOption){

                    newIndex = isPrevious ? i - 1 : i + 1;
                    break;
                }
            }
        }

        // clamp if invalid.
        if(newIndex < 0) {

            newIndex = sequentialBrands.length - 1;
        } else if(newIndex > sequentialBrands.length - 1){

            newIndex = 0;
        }

        this.brandFilter.setSelectedOption(sequentialBrands[newIndex].brandItem.id)
        this.brandFilter.setSelectedOptionText(sequentialBrands[newIndex].brandItem.name)
        this.caller.filterSingleGroupSelectorOnChange('brandFilter');
    }

    public toggleTopPagesBrandFilter() {

        const isOpen = this.getTemplateViewModel().isTopPagesBrandFilterOpen();
        this.getTemplateViewModel().isTopPagesBrandFilterOpen(!isOpen);
    }

    public onTopPagesBrandOptionChange(item: any) {

        this.brandFilter.setSelectedOption(item.id);
        this.brandFilter.setSelectedOptionText(item.name);
        this.getTemplateViewModel().isTopPagesBrandFilterOpen(false);
        this.caller.filterSingleGroupSelectorOnChange('brandFilter');
    }

    private getEncodedViewModelParams(): string {

        let viewModel = this.getViewModelForRequest();
        let params = new URLSearchParams();

        for (const [key, value] of Object.entries(viewModel['filters'])) {
            params.append(key, ko.toJSON(value));
        }

        return params.toString();
    }

    public reorderTableData(data, column) {

        const currentOrdering = this.getTemplateViewModel().tableOrdering();

        if(currentOrdering.col == null || currentOrdering.col != column) {

            this.getTemplateViewModel().tableOrdering({ col: column, dir: 'DESC'});
        } else if(currentOrdering.col == column && currentOrdering.dir == 'DESC') {

            this.getTemplateViewModel().tableOrdering({ col: column, dir: 'ASC' });
        } else {

            this.getTemplateViewModel().tableOrdering({ col: null, dir: null });
        }

        this.caller.getTableData(true);
    }

    public isMetricColumnVisible(column: string): boolean {

        return !!this.getTemplateViewModel().collapsibleMetricColumns()[column];
    }

    public toggleMetricColumn(column: string) {

        const visibleColumns = this.getTemplateViewModel().collapsibleMetricColumns();

        this.getTemplateViewModel().collapsibleMetricColumns(Object.assign({}, visibleColumns, {
            [column]: !visibleColumns[column]
        }));
    }

    protected onMouseOverPreset(){

        this.getTemplateViewModel().isPresetVisible(true);
    }

    protected onMouseOutPreset(){

        this.getTemplateViewModel().isPresetVisible(false);
    }

    public getPercentOfTotal(data){

        let totals = this.getTemplateViewModel().totalsData().latestTotals;

        if (!totals || !data) {

            return 0;
        }

        let type = this.getTemplateViewModel().visitsViewsToggle();

        if (type == 'visits') {

            return totals.visitCountTotal == 0 ? 0 : (parseInt(data.visitCount) / parseInt(totals.visitCountTotal)) * 100.0;
        } else if(type == 'views'){

            return totals.viewCountTotal == 0 ? 0 : (parseInt(data.viewCount) / parseInt(totals.viewCountTotal)) * 100.0;
        } else {

            return 0;
        }

    }

    public getWidgetDataByKey(key: string): any {

        let widgetDataArray = this.getTemplateViewModel().reportWidgetData();
        let widgetData = null;
        if(widgetDataArray.length > 0){

            widgetData = widgetDataArray.find(data => data.hasOwnProperty(key));
            widgetData = widgetData ? widgetData[key] : null;
        }

        return widgetData;
    }

    public getWidgetGraphHtml(widgetType: string, widgetName: string): any {

        if (widgetType === 'graph') {

            if (widgetName === 'Ping Graph') {

                return '<div class="w-card has-chart">' + this.pingDiffIndicatorsChart.getHtmlBuild() + '</div>';
                //return widgetName;
            } else if (widgetName === 'Ping Load Time') {

                return '<div class="w-card has-chart">' + this.pingAvgLoadIndicatorsChart.getHtmlBuild() + '</div>';
                //return widgetName;
            }
        }

        return null;
    }

    public toggleBotMode() {

        this.getTemplateViewModel().isBotMode(!this.getTemplateViewModel().isBotMode());

        const filter = this.getTemplateViewModel().dynamicFilters().find(f => f.filterId == 'device-internalDimension').filter;
        let selectedItems = filter.getItems().filter(i => i && filter.getSelectedItems().includes(i.id));
        let botDevices = ['Bot'];
        let hasBots = selectedItems.filter(i => botDevices.includes(i.name)).length > 0 ? true : false;

        let newFilterItems, newFilterItemIds;
        if(hasBots){

            newFilterItems = selectedItems.filter(i => i && !botDevices.includes(i.name));
            newFilterItemIds = newFilterItems.map(i => i.id);
        }
        else{

            newFilterItems = filter.getItems().filter(i => i && botDevices.includes(i.name)).concat(selectedItems);
            newFilterItemIds = newFilterItems.map(i => i.id);

        }
        filter.setSelectedItems(newFilterItems);
        filter.setTags(newFilterItemIds, filter.getItems());

        this.caller.getReportData();
    }


    public setBotMode() {

        const filter = this.getTemplateViewModel().dynamicFilters().find(f => f.filterId == 'device-internalDimension').filter;
        let selectedItems = filter.getItems().filter(i => i && filter.getSelectedItems().includes(i.id));
        let botDevices = ['Bot'];
        let hasBots = selectedItems.filter(i => botDevices.includes(i.name)).length > 0 ? true : false;

        if(hasBots){

            this.getTemplateViewModel().isBotMode(true);
        }
        else{

            this.getTemplateViewModel().isBotMode(false);
        }
    }

    public onDimensionGroupSwitch(data, event){

        if(data !== 'time' && this.getTemplateViewModel().tableOrdering().col === 'intervalCpm'){
            this.getTemplateViewModel().tableOrdering({ col: null, dir: null });
        }
        this.getTemplateViewModel().dimensionGroupSwitch(data);
        this.caller.getIndicatorsByDateData();
        this.caller.getTableData(true);
    }

    public onSidebarToggle(){

        this.getTemplateViewModel().sidebarToggle(!this.getTemplateViewModel().sidebarToggle())
    }

    public isWidgetItemSelected(data, filterId){

        if(!data) return;

        const filter = this.getTemplateViewModel().dynamicFilters().find(f => f.filterId == filterId).filter;

        let selectedItems;
        if(filter.getTemplateName() === 'multiSelector-template'){

            selectedItems = filter.getItems().filter(i => filter.getSelectedItems().includes(i.id))
        }
        else{

            selectedItems = filter.getSelectedItems();
        }

        let isSelected = selectedItems && selectedItems.find(i => i.name == data.dimension) ? true : false;

        return isSelected;
    }

    public toggleWidgetFilter(data, filterId){

        if(!data) return;

        const filter = this.getTemplateViewModel().dynamicFilters().find(f => f.filterId == filterId).filter;
        if(filter.getTemplateName() === 'multiSelector-template'){

            this.widgetFilterMultiSelectItem(filter, data.dimension);
        }
        else{

            this.widgetFilterMultiAutocompleteSelectItem(filter, data.dimensionId, data.dimension);
        }
    }

    private widgetFilterMultiAutocompleteSelectItem(filter, itemId: number, itemLabel: string){

        const selectedItems = filter.getSelectedItems();

        if(selectedItems){

            if (!selectedItems.find(i => i.name == itemLabel)) {

                this.presetFilter.setMultipleAutocompletePresetFilter(filter, [itemId], [itemLabel]);
                this.caller.filterMultipleSelectorOnChange();
            } else {

                let updatedSelectedItems = selectedItems.filter(i => i.name != itemLabel);
                let ids = updatedSelectedItems.map(i => i.id);
                let names = updatedSelectedItems.map(i => i.name);

                // if no items, pass null
                ids = ids.length == 0 ? [] : [ids];
                names = names.length == 0 ? [] : [names];

                this.presetFilter.setMultipleAutocompletePresetFilter(filter, ids, names);
                this.caller.filterMultipleSelectorOnChange();
            }
        } else {

            this.presetFilter.setMultipleAutocompletePresetFilter(filter);
            this.caller.filterMultipleSelectorOnChange();
        }
    }

    private widgetFilterMultiSelectItem(filter, itemLabel: string){

        const selectedItemIds = filter.getSelectedItems();
        const widgetItem = filter.getItems().find(i => i && i.name == itemLabel);

        if (!selectedItemIds.includes(widgetItem.id)) {

            this.presetFilter.setMultiSelectorPresetFilters(filter, [widgetItem.id]);
            this.caller.filterMultipleSelectorOnChange();
        } else {

            let updatedSelectedItemIds = selectedItemIds.filter(i => i != widgetItem.id);

            this.presetFilter.setMultiSelectorPresetFilters(filter, updatedSelectedItemIds);
            this.caller.filterMultipleSelectorOnChange();
        }
    }

    public widgetNoData(type: string){

        let totals = this.getTemplateViewModel().totalsData();
        let metric = this.metricFilter.getSelectedOption();


        if (!totals || totals.length == 0) {

            return false;
        }

        totals = totals.latestTotals;


        switch(type){
            case 'source': {
                if(metric == 'views'){
                    return totals.sourceViewTotals.length == 0;
                } else if(metric == 'visits'){
                    return totals.sourceVisitTotals.length == 0;
                }
            }
            case 'device': {
                if(metric == 'views'){
                    return totals.deviceViewTotals.length == 0;
                } else if(metric == 'visits'){
                    return totals.deviceVisitTotals.length == 0;
                }
            }
            case 'os': {
                if(metric == 'views'){
                    return totals.osViewTotals.length == 0;
                } else if(metric == 'visits'){
                    return totals.osVisitTotals.length == 0;
                }
            }
            case 'geo': {
                if(metric == 'views'){
                    return totals.geoViewTotals.length == 0;
                } else if(metric == 'visits'){
                    return totals.geoVisitTotals.length == 0;
                }
            }

            default: return false;
        }
    }

    public clearSnapshot() {

        this.getTemplateViewModel().snapshotDateTime(null);
        let chart = this.getTemplateViewModel().indicatorsChartObj();

        chart.series.values[0].xAxis.axisRanges.clear(); // clear axis ranges from chart view
        this.caller.loadSnapshot(); // calling it with snapshotDateTime set to null resets the dash totals
    }

    public setReportWidgetColumnLayout(reportWidgetColumnLayout: Array<any>){

        this.getTemplateViewModel().reportWidgetColumnLayout(reportWidgetColumnLayout);
    }

    public setReportWidgetData(widgetData: Array<any>, name: string){

        let reportWidgetDataArray = this.getTemplateViewModel().reportWidgetData();
        this.getTemplateViewModel().reportWidgetData(reportWidgetDataArray.filter(data => !data.hasOwnProperty(name)));

        let dataObject = { [name]: widgetData };
        this.getTemplateViewModel().reportWidgetData.push(dataObject);
    }

    public setDynamicFilters(dynamicFiltersData: Array<any>){

        let i = 0;
        let dynamicFilters = [];
        let segmentException = this.getTemplateViewModel().segmentsFilterException();

        for (let category in dynamicFiltersData) {

            if (dynamicFiltersData.hasOwnProperty(category)) {

                let filtersData = dynamicFiltersData[category];

                filtersData.forEach((filterData) => {

                    let filter, filterId;

                    // multi select
                    if(filterData.type === 'multiSelect'){

                        filterId = filterData.id;
                        filter = new multipleSelector_template(filterId, this.getTemplateViewModel(), this.caller);
                        filter.setLabel(filterData.name);
                        filter.setTagContainerId('selected-' + filterData.name);
                        filter.setTagContainerCaption('Selected ' + filterData.name + ':');
                        filter.setItems(filterData.values);

                        if(!(segmentException && filterData.name == 'segment') && !(segmentException && filterData.name == 'system')){

                            filter.setShowCount(true);
                            filter.setShowClear(true);

                            if(filterData.hasSearchFilter){

                                filter.setContainSearchEnabled(true);
                            }
                        }

                        dynamicFilters.push({
                            filter: filter,
                            filterId: filterId,
                            name: filterData.name,
                            type: filterData.type,
                            category: filterData.category,
                            categoryName: filterData.categoryName
                        });
                    }
                    // multi select autocomplete
                    else if(filterData.type === 'autoCompleteMultiSelect'){

                        filterId = filterData.id;
                        filter = new filterMultipleAutoComplete_template(filterId, this.getTemplateViewModel(), this.caller);
                        filter.setIsVisible(1);
                        //filter.setPlaceHolderText(filterData.name);
                        filter.setIcon("i-tag-a");
                        filter.setTagContainerId('selected-' + filterData.name);
                        filter.setTagContainerCaption('Selected ' + filterData.name + ':');
                        filter.setMinInputSuggestionLength(2);
                        filter.setLabel(filterData.name);

                        if(!(segmentException && filterData.name == 'segment') && !(segmentException && filterData.name == 'system')){

                            filter.setShowCount(true);
                            filter.setShowClear(true);

                            if(filterData.hasSearchFilter){

                                filter.setContainSearchEnabled(true);
                            }
                        }

                        dynamicFilters.push({
                            filter: filter,
                            filterId: filterId,
                            name: filterData.name,
                            type: filterData.type,
                            category: filterData.category,
                            categoryName: filterData.categoryName
                        });
                    }
                    else if(filterData.type === 'searchField'){

                        filterId = filterData.id;
                        filter = new filterSimple_template(filterId, this.getTemplateViewModel(), this.caller);
                        filter.setLabel(filterData.name);

                        dynamicFilters.push({
                            filter: filter,
                            filterId: filterId,
                            name: filterData.name,
                            type: filterData.type,
                            category: filterData.category,
                            categoryName: filterData.categoryName
                        });
                    }
                })
            }
        }

        this.getTemplateViewModel().dynamicFilters(dynamicFilters);

        let dynamicFiltersGrouped = Object.values(dynamicFilters.reduce((acc, item) => {

            // Check if the category already exists
            if (!acc[item.categoryName]) {
                acc[item.categoryName] = {
                    categoryName: item.categoryName,
                    names: {}
                };
            }

            // Check if the name already exists within the category
            if (!acc[item.categoryName].names[item.name]) {
                acc[item.categoryName].names[item.name] = {
                    name: item.name,
                    filters: []
                };
            }

            // Push the filter into the correct name group
            acc[item.categoryName].names[item.name].filters.push({
                type: item.type,
                filter: item.filter,
                filterId: item.filterId
            });

            return acc;
        }, {}));

        this.getTemplateViewModel().dynamicFiltersGrouped(dynamicFiltersGrouped);

        let dynamicFiltersGroupedByName = Object.values(dynamicFilters.reduce((acc, item) => {

            if (!acc[item.name]) {
                acc[item.name] = { name: item.name, category: item.category, filters: [] };
            }
            acc[item.name].filters.push({ type: item.type, filter: item.filter, filterId: item.filterId });
            return acc;
        }, {}));

        this.getTemplateViewModel().dynamicFiltersGroupedByName(dynamicFiltersGroupedByName);

        // Custom dimension names
        let customDimensionsNames = dynamicFilters.reduce((acc, item) => {
            if (item.category === "Custom Dimensions" && !acc.find(obj => obj.name === item.name)) {
                acc.push({ name: item.filterId.split('-')[0] });
            }
            return acc;
        }, []);

        this.getTemplateViewModel().customDimensionsNames(customDimensionsNames);
    }

    public setSegmentsFilterException(segmentsFilterException){

        this.getTemplateViewModel().segmentsFilterException(segmentsFilterException);
    }

    public setSystemsFilterException(systemsFilterException){

        this.getTemplateViewModel().systemsFilterException(systemsFilterException);
    }

    public setUsColumnException(usColumnException){

        this.getTemplateViewModel().usColumnException(usColumnException);
    }

    public setBotToggleButtonException(botToggleButtonException){

        this.getTemplateViewModel().botToggleButtonException(botToggleButtonException);
    }

    public setCpmColumnVisible(cpmColumnVisible){

        this.getTemplateViewModel().cpmColumnVisible(!!cpmColumnVisible);
    }

    public setDeltaToggleButtonException(deltaToggleButtonException){

        this.getTemplateViewModel().deltaToggleButtonException(deltaToggleButtonException);

        const isInitialized = this.getTemplateViewModel().deltaToggleButtonInitialized();
        this.setDeltaFilterItems(deltaToggleButtonException);

        if(isInitialized){

            const sanitized = this.sanitizeDeltaMode(this.deltaFilter.getSelectedOption());
            this.deltaFilter.setSelectedOption(sanitized);
            this.deltaFilter.setSelectedOptionText(this.getDeltaOptionName(sanitized));
            this.getTemplateViewModel().deltaMode(sanitized);
            return;
        }

        const defaultMode = deltaToggleButtonException ? 'segmentSystemAverage' : 'filterAverage';
        this.deltaFilter.setSelectedOption(defaultMode);
        this.deltaFilter.setSelectedOptionText(this.getDeltaOptionName(defaultMode));
        this.getTemplateViewModel().deltaMode(defaultMode);
        this.getTemplateViewModel().deltaToggleButtonInitialized(true);
    }

    public setDynamicAutoCompleteMultiSelectFilterItems(filterId, items){

        let dynamicFilters = this.getTemplateViewModel().dynamicFilters();
        let filter = dynamicFilters.find(filters => filters.filter.idElement === filterId).filter;
        if (filter) {

            filter.setItems(items);
            this.getTemplateViewModel().dynamicFilters(dynamicFilters);
        }
        filter.setItems(items);
    }

    public getNiceIntervalName(){

        const snapshotDate = this.getTemplateViewModel().snapshotDateTime();

        if(snapshotDate){

            const endDate = new Date(snapshotDate);
            const intervalMinutes = this.intervalFilter.getSelectedOption();
            const startDate = new Date(endDate.getTime() - intervalMinutes * 60000)

            return `${this.formatSnapshotDate(startDate)} - ${this.formatSnapshotDate(endDate)}`;

        } else {

            return `Last ${this.intervalFilter.getSelectedOption()} Minutes`;
        }
    }

    public showMoreTopStats(){
        this.getTemplateViewModel().isTopStatsOpen(true);
    }

    public getMainDashTooltip() {

        let mainDashTooltipContent = `
                <p>Displays data from the past five minutes, with percentages comparing this interval to the average for the same 15-minute block during the selected comparison period (e.g., today's 10:00–10:05 a.m. vs. last week's 9:50–10:05 a.m.).</p>`;

        const mainDashTooltip = new infoButton_template('mainDashTooltip', this.getTemplateViewModel(), this.caller);
        mainDashTooltip.setContent(mainDashTooltipContent);

        return mainDashTooltip;
    }

    public getEngagedPagesTooltip() {

        return this.engagedPagesTooltip;
    }

    public getEngagedBreakdownTooltip(duration: string) {

        return this.engagedBreakdownTooltips[duration];
    }

    public getAvgViewDurationTooltip() {

        return this.avgViewDurationTooltip;
    }

    public getEngagedOrderColumn() {

        return this.getTemplateViewModel().visitsViewsToggle() == 'visits' ? 'engagedVisitCount' : 'engagedViewCount';
    }

    public getRelativePerformanceTooltip() {

        return this.relativePerformanceTooltip;
    }

    public getTimeOnPageTooltip() {

        return this.timeOnPageTooltip;
    }

    public getInteractionRatioTooltip() {

        return this.interactionRatioTooltip;
    }

    public toggleOpenFilters() {

        this.getTemplateViewModel().isFiltersOpen(!this.getTemplateViewModel().isFiltersOpen());
    }

    public toggleOpenMetrics() {

        this.getTemplateViewModel().isMetricsOpen(!this.getTemplateViewModel().isMetricsOpen());
    }

    public setDeviceView(deviceView) {

        this.getTemplateViewModel().deviceView(deviceView);
    }

    public setDevice(device) {

        this.getTemplateViewModel().device(device);
    }

    public onBrandSelection(brandId){

        this.getTemplateViewModel().selectedBrand(brandId);
        this.caller.getReportData();
    }

    public onClickRowClick(index){

        let selectedRows = this.getTemplateViewModel().selectedRows();
        let check = selectedRows.indexOf(index);
        if (check !== -1) {

            selectedRows.splice(check, 1);
        }else {

            selectedRows.push(index);
        }

        this.getTemplateViewModel().selectedRows(selectedRows);
    }

    public setReportStatusData(reportStatusData) {

        this.getTemplateViewModel().reportStatusData(reportStatusData);
    }

    public setSampledDatesData(sampledDatesData) {

        this.getTemplateViewModel().sampledDatesData(sampledDatesData);
    }

    public setComparisonFilterItems() {

        const options = this.comparisonValues;

        let filterItems = options.map(o => {
            return {
                id: o.id,
                name: o.name,
                type: "",
                cssClasses: ""
            }
        });

        // set the groups manually (dont use setGroups here)
        this.comparisonFilter.getTemplateViewModel().groups(filterItems);

        // set default
        this.comparisonFilter.setSelectedOption(filterItems[0].id);
        this.comparisonFilter.setSelectedOptionText(filterItems[0].name);
        this.getTemplateViewModel().comparisonSwitch(filterItems[0].id);
    }

    public setMetricFilterItems() {

        const options = this.metricValues;

        let filterItems = options.map(o => {
            return {
                id: o.id,
                name: o.name,
                type: "",
                cssClasses: ""
            }
        });

        // set the groups manually (dont use setGroups here)
        this.metricFilter.getTemplateViewModel().groups(filterItems);

        // set default
        this.metricFilter.setSelectedOption(filterItems[0].id);
        this.metricFilter.setSelectedOptionText(filterItems[0].name);
        this.getTemplateViewModel().comparisonSwitch(filterItems[0].id);
    }

    public setIntervalFilterItems() {

        const options = this.intervalValues;

        let filterItems = options.map(o => {
            return {
                id: o.id,
                name: o.name,
                type: "",
                cssClasses: ""
            }
        });

        // set the groups manually (dont use setGroups here)
        this.intervalFilter.getTemplateViewModel().groups(filterItems);

        const device = this.caller.getVnAppZone().getCookie('device');
        const deviceView = this.caller.getVnAppZone().getCookie('deviceView');

        if((device == 'mobile' && deviceView == 'mobile')) {

            // set mobile
            this.intervalFilter.setSelectedOption(filterItems[4].id);
            this.intervalFilter.setSelectedOptionText(filterItems[4].name);
        } else {

            // set default
            this.intervalFilter.setSelectedOption(filterItems[0].id);
            this.intervalFilter.setSelectedOptionText(filterItems[0].name);
        }
    }

    public setDeltaFilterItems(isException: boolean) {

        const options = isException ? this.deltaValuesExtended : this.deltaValuesDefault;

        let filterItems = options.map(o => {
            return {
                id: o.id,
                name: o.name,
                type: "",
                cssClasses: ""
            }
        });

        this.deltaFilter.getTemplateViewModel().groups(filterItems);
    }

    public updateDeltaMode() {

        const selected = this.deltaFilter.getSelectedOption();
        this.getTemplateViewModel().deltaMode(this.sanitizeDeltaMode(selected));
    }

    private getDeltaOptionName(id: string): string {

        const allOptions = [...this.deltaValuesExtended];
        const match = allOptions.find(o => o.id === id);
        return match ? match.name : '';
    }

    public stopPropagation(event){

        event.stopPropagation();
    }

    /**
     * @inheritDoc
     */
    public getViewModelForRequest() {

        let selectedDynamicFilters = [];
        let dynamicFilters = this.getTemplateViewModel().dynamicFilters();
        if(typeof dynamicFilters !== "undefined" && dynamicFilters !== null && Object.keys(dynamicFilters).length !== 0) {

            for(let dynamicFilter of dynamicFilters) {

                if(dynamicFilter.type === 'multiSelect') {

                    let items = dynamicFilter.filter.getTemplateViewModel().items();
                    let searchKeyword = dynamicFilter.filter.getContainSearchFilterKeyword();
                    let selectedIds = dynamicFilter.filter.getTemplateViewModel().selectedItems();
                    let filteredItems = items.filter(item => selectedIds.includes(item.id));

                    if(filteredItems && (filteredItems.length > 0 || searchKeyword)) {

                        selectedDynamicFilters.push({

                            [dynamicFilter.category]: {

                                [dynamicFilter.name]: {

                                    id: dynamicFilter.filterId,
                                    type: dynamicFilter.type,
                                    items: filteredItems,
                                    keyword: searchKeyword
                                }
                            }
                        });
                    }
                }
                else if(dynamicFilter.type === 'autoCompleteMultiSelect') {

                    let selectedIds = dynamicFilter.filter.getTemplateViewModel().selectedItems();
                    let searchKeyword = dynamicFilter.filter.getContainSearchFilterKeyword();
                    let filteredItems = selectedIds;

                    if(filteredItems && (filteredItems.length > 0 || searchKeyword)) {

                        selectedDynamicFilters.push({

                            [dynamicFilter.category]: {

                                [dynamicFilter.name]: {

                                    id: dynamicFilter.filterId,
                                    type: dynamicFilter.type,
                                    items: filteredItems,
                                    keyword: searchKeyword
                                }
                            }
                        });
                    }
                }
                else if(dynamicFilter.type === 'searchField') {

                    let searchKeyword = dynamicFilter.filter.getTemplateViewModel().filterKeyword();

                    if(searchKeyword) {

                        selectedDynamicFilters.push({

                            [dynamicFilter.category]: {
                                [dynamicFilter.name]: {
                                    id: dynamicFilter.filterId,
                                    type: dynamicFilter.type,
                                    keyword: searchKeyword
                                }
                            }
                        });
                    }
                }
            }
        }

        return {
            /* pagination: this.pagination.getTemplateViewModel().pageNumber(),
            orderBy: this.getTemplateViewModel().orderBy(),
            orderByDirection: this.getTemplateViewModel().orderByDirection(), */
            filters: {
                selectedBrand: this.brandFilter.getTemplateViewModel().selectedOption(),
                selectedBrandText: this.brandFilter.getTemplateViewModel().selectedOptionText(),
                comparisonSwitch: this.comparisonFilter.getTemplateViewModel().selectedOption(),
                comparisonSwitchText: this.comparisonFilter.getTemplateViewModel().selectedOptionText(),
                visitsViewsToggle: this.metricFilter.getTemplateViewModel().selectedOption(),
                visitsViewsToggleText: this.metricFilter.getTemplateViewModel().selectedOptionText(),
                selectedInterval: this.intervalFilter.getTemplateViewModel().selectedOption(),
                selectedIntervalText: this.intervalFilter.getTemplateViewModel().selectedOptionText(),
                snapshotDateTime: this.getTemplateViewModel().snapshotDateTime(),
                selectedDynamicFilters: selectedDynamicFilters,
                dimensionGroupSwitch: this.getTemplateViewModel().dimensionGroupSwitch(),
                isBotMode: this.getTemplateViewModel().isBotMode(),
                deltaMode: this.sanitizeDeltaMode(this.deltaFilter.getSelectedOption()),
                pagination: this.getTemplateViewModel().pagination,
                tableOrdering: this.getTemplateViewModel().tableOrdering()
            }
        };
    }

    public updatePagination(totalCount){

        this.pagination.setNumberItemToPaginate(totalCount);
    }

    /**
     * Build the date Picker calendar.
     */
    public buildDatePickerCalendar(){

        this.dateRangeFilter.buildCalendar();
        this.compRangeFilter.buildCalendar();
    }

    public setBrandFilterItems(portfolios): void{
        let groups = [];
        let sequentialBrands: any[] = [];

        this.brandFilter.setIncludeAllOptions(true);

        for(let portfolio of portfolios){

            let subGroups = [];

            let portfolioItem = {"id": portfolio.id, "name": portfolio.name, "cssClasses": portfolio.logo, "type": 'portfolio'};

            if (!(typeof(portfolio.disabled) !== 'undefined' && portfolio.disabled === true)){

                groups.push(portfolioItem);

                for(let brand of portfolio.brands){

                    let brandItem = {"id": brand.id, "name": brand.name, "cssClasses": brand.logo, "iconUrl": brand.logoUrl, "type": 'brand'};

                    subGroups.push(brandItem);
                    sequentialBrands.push({brandItem, portfolioId: "portfolio_" + portfolio.id});
                }
                portfolioItem['subGroups'] = subGroups;
            } else {

                for(let brand of portfolio.brands){

                    let brandItem = {"id": brand.id, "name": brand.name, "cssClasses": brand.logo, "iconUrl": brand.logoUrl, "type": 'brand'};
                    groups.push(brandItem);
                    sequentialBrands.push({brandItem, portfolioId: "portfolio_" + portfolio.id});
                }
            }

        }

        // call setGroups function

        this.brandFilter.setGroups(groups);
        this.getTemplateViewModel().sequentialBrands(sequentialBrands);
        //this.brandFilter.setSelectedOption('all');
    }

    public setViewModeFilterItems(viewModes): void{

        this.viewModeFilter.setOptions(viewModes);
    }

    public setMultiSegmentsFilterItems(segments){

        let groups = [];
        for (let segment of segments){

            let group = {"name" : segment.name, "items" : segment.categories};
            groups.push(group);
        }

        this.multiSegmentsFilter.setMultiSectionItems(groups);
        this.multiSegmentsFilter.setLabel('Segments');
    }

    public setSegmentsFilterItems(segments): void{

        this.segmentsFilter.setOptions(segments);
    }

    public updatePingDiffIndicatorsChartGraphData(){

        let deviceHeight = (this.getTemplateViewModel().deviceView() === 'mobile') ? 100 : 153;
        this.pingDiffIndicatorsChart.setCssHeight(deviceHeight + "px");
        this.pingDiffIndicatorsChart.setNbOfXAxes(1);
        this.pingDiffIndicatorsChart.setDeviceView(this.getTemplateViewModel().deviceView());
        this.pingDiffIndicatorsChart.setDateFormat("fiveMinutes");
        this.pingDiffIndicatorsChart.setDateFields(["dateTime"]);
        this.pingDiffIndicatorsChart.setCursorEnabled(1);
        this.pingDiffIndicatorsChart.setLabelMaxWidth(80);
        this.pingDiffIndicatorsChart.setAutoRotateLabels(0);
        this.pingDiffIndicatorsChart.setClickableLegend(1);
        this.pingDiffIndicatorsChart.setXScrollbarEnabled(0);

        let chart = this.pingDiffIndicatorsChart.setupChart(this.getTemplateViewModel().pingDiffIndicatorsDateRange().data);

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

        // Set initial padding
        let initialPaddingValue = 15;

        // Target value where padding should decay to 0 (when maxDataValue approaches 50)
        let targetValue = 50;

        // Rate of exponential decay (tune for desired decay rate)
        let decayConstant = 0.1;

        // Calculate max data value from your dataset
        let maxDataValue = Math.max(...chart.data.map(item => item.pingDiffPositive));

        // Calculate the exponential scale factor: decreases as maxDataValue grows
        let scaleFactor = Math.exp(-decayConstant * (maxDataValue / targetValue));

        // Calculate the new padding based on initial percentage, decaying exponentially as maxDataValue increases
        let scaledPadding = initialPaddingValue * scaleFactor;

        // Apply symmetrical padding to min and max
        valueAxis.min = -maxDataValue - scaledPadding;
        valueAxis.max = maxDataValue + scaledPadding;
        valueAxis.strictMinMax = true;
        // Set the interval for the y-axis
        valueAxis.renderer.minGridDistance = 10;

        this.pingDiffIndicatorsChart.applyValueAxisFormatting(valueAxis);
        valueAxis.renderer.minWidth = 50;
        valueAxis.renderer.grid.template.disabled = true;
        valueAxis.title.fontWeight = "bold";
        valueAxis.numberFormatter.numberFormat = "#a";
        valueAxis.tooltip.disabled = true;  // Disable Y-axis tooltip

        chart.zoomOutButton.background.fillOpacity = 0.35;

         // Get the date X-axis and hide labels
        let dateAxis = this.pingDiffIndicatorsChart.getDateAxes()[0];
        dateAxis.renderer.labels.template.disabled = true; // Hide X-axis labels

        // Disable the legend
        chart.legend.markers.template.disabled = true;
        chart.legend.labels.template.disabled = true;
        chart.padding(10, 0, 0, 0);

        // Create a tooltip-specific value
        chart.events.on("beforedatavalidated", function() {

            chart.data.forEach(item => {

                item.tooltipValue = item.pingDiffPositive * 2;  // Multiply and store in tooltipValue only
            });
        });

        for (let graphLineInfo of this.getTemplateViewModel().pingDiffIndicatorsDateRange().graphLinesInfo) {

            let series = chart.series.push(new am4charts.LineSeries());
            series.dataItems.template.locations.categoryX = 0.5;
            series.dataFields.valueY = graphLineInfo.field;
            series.dataFields.customValue = graphLineInfo.field;
            series.dataFields.dateX = "dateTime";
            series.strokeOpacity = 0;
            series.strokeWidth = 0;
            series.xAxis = this.pingDiffIndicatorsChart.getDateAxes()[0];
            series.xAxis.renderer.labels.template.fill = am4core.color("#313050");
            series.yAxis = valueAxis;
            series.name = graphLineInfo.name;

            if(graphLineInfo.field === "pingDiffPositive"){

                series.tooltipText = "[bold]{tooltipValue.formatNumber('#.##')}%[/]";
            }

            series.fillOpacity = 0.5;
            series.fill = am4core.color("#a367dc");
            series.stroke = am4core.color("#a367dc");

            series.smoothing = "monotoneX";
            series.showOnInit = true;
        }

        if(chart.logo){

            chart.logo.disabled = true;
        }
    }

    public updatePingAvgLoadIndicatorsChartGraphData(){

        let deviceHeight = (this.getTemplateViewModel().deviceView() === 'mobile') ? 100 : 153;
        this.pingAvgLoadIndicatorsChart.setCssHeight(deviceHeight + "px");
        this.pingAvgLoadIndicatorsChart.setNbOfXAxes(1);
        this.pingAvgLoadIndicatorsChart.setDeviceView(this.getTemplateViewModel().deviceView());
        this.pingAvgLoadIndicatorsChart.setDateFormat("fiveMinutes");
        this.pingAvgLoadIndicatorsChart.setDateFields(["dateTime"]);
        this.pingAvgLoadIndicatorsChart.setCursorEnabled(1);
        this.pingAvgLoadIndicatorsChart.setLabelMaxWidth(80);
        this.pingAvgLoadIndicatorsChart.setAutoRotateLabels(0);
        this.pingAvgLoadIndicatorsChart.setClickableLegend(1);
        this.pingAvgLoadIndicatorsChart.setXScrollbarEnabled(0);

        let chart = this.pingAvgLoadIndicatorsChart.setupChart(this.getTemplateViewModel().pingAvgLoadIndicatorsDateRange().data);

        // Get the date X-axis and hide labels
        let dateAxis = this.pingAvgLoadIndicatorsChart.getDateAxes()[0];
        dateAxis.renderer.labels.template.disabled = true; // Hide X-axis labels

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        this.pingAvgLoadIndicatorsChart.applyValueAxisFormatting(valueAxis);
        valueAxis.renderer.minWidth = 50;
        valueAxis.renderer.grid.template.disabled = true;
        valueAxis.title.fontWeight = "bold";
        valueAxis.min = 0;
        valueAxis.numberFormatter.numberFormat = "#a";
        valueAxis.tooltip.disabled = true;  // Disable Y-axis tooltip

        chart.zoomOutButton.background.fillOpacity = 0.35;

        // Disable the legend
        chart.padding(10, 0, 0, 0);
        chart.legend.markers.template.disabled = true;
        chart.legend.labels.template.disabled = true;

        for (let graphLineInfo of this.getTemplateViewModel().pingAvgLoadIndicatorsDateRange().graphLinesInfo) {

            let series = chart.series.push(new am4charts.LineSeries());
            series.dataItems.template.locations.categoryX = 0.5;
            series.dataFields.valueY = graphLineInfo.field;
            series.dataFields.customValue = graphLineInfo.field;
            series.dataFields.dateX = "dateTime";
            series.strokeOpacity = 1;
            series.strokeWidth = 1;
            series.xAxis = this.pingAvgLoadIndicatorsChart.getDateAxes()[0];
            series.xAxis.renderer.labels.template.fill = am4core.color("#313050");
            series.yAxis = valueAxis;
            series.name = graphLineInfo.name;
            series.tooltipText = "[bold]{customValue.formatNumber('#')}ms[/]";

            series.fillOpacity = 0.2;
            series.fill = am4core.color("#a367dc");
            series.stroke = am4core.color("#a367dc");

            series.smoothing = "monotoneX";
            series.showOnInit = true;
        }

        if(chart.logo){

            chart.logo.disabled = true;
        }
    }

    public updateIndicatorsGraphData(){

        const onHit = function(ev, series){

                        if (!series.visible) {

                            if((series.xAxis as am4charts.DateAxis).axisRanges.length > 0){

                                self.clearSnapshot();
                            }
                            return;
                        };

                        let dataItem = series.tooltipDataItem as am4charts.LineSeriesDataItem;
                        let data: any = dataItem!.dataContext;

                        // if not found, do nothing
                        if(!data) return;

                        // clear old marker
                        (series.xAxis as am4charts.DateAxis).axisRanges.clear();

                        // create new at clicked date
                        let range = (series.xAxis as am4charts.DateAxis).axisRanges.create();
                        range.date = new Date(data.dateTime.getTime() + 150000); // 2.5min in ms (half of a live dash interval)

                        // style
                        range.grid.stroke = am4core.color("#0F64A3");
                        range.grid.strokeWidth = 3;
                        range.grid.strokeOpacity = 1;

                        if(data.dateTime){

                            // force timezone to be local time by stripping the "fake" UTC from the local time and getting it's REAL UTC time :) if you're confused, as you should be, ask nick
                            const dateParts = data.dateTime.toISOString().split('T');
                            let dateString = dateParts[0] + ' ' + dateParts[1].slice(0, -1);

                            self.getTemplateViewModel().snapshotDateTime(dateString)
                            self.caller.loadSnapshot();
                        } else {

                            console.warn('No date time found.')
                        }
                    };

        const onReady = function(ev, series){

                        let dateTime = self.getTemplateViewModel().snapshotDateTime();

                        if(!dateTime) return;

                        // clear old marker
                        (series.xAxis as am4charts.DateAxis).axisRanges.clear();

                        // create new at clicked date. some whacky stuff for getting the date marker to show up at the right place.
                        let range = (series.xAxis as am4charts.DateAxis).axisRanges.create();
                        dateTime = new Date(dateTime);
                        let offset = (dateTime.getTimezoneOffset() * 60 * 1000);
                        dateTime = new Date(dateTime.getTime() - offset + 150000);
                        range.date = dateTime;

                        //dateTime = new Date(dateTime.getTime() + 150000)
                        // style
                        range.grid.stroke = am4core.color("#0F64A3");
                        range.grid.strokeWidth = 3;
                        range.grid.strokeOpacity = 1;
                    }

        const self = this;

        if(this.getTemplateViewModel().dimensionGroupSwitch() == 'time') {

            this.indicatorsChart.setCssHeight("250px");
            this.indicatorsChart.setNbOfXAxes(2);
            this.indicatorsChart.setDeviceView(this.getTemplateViewModel().deviceView());
            this.indicatorsChart.setDateFormat("fiveMinutes");
            this.indicatorsChart.setDateFields(["dateTime","compDateTime"]);
            this.indicatorsChart.setCursorEnabled(1);
            this.indicatorsChart.setLabelMaxWidth(80);
            this.indicatorsChart.setAutoRotateLabels(0);
            this.indicatorsChart.setClickableLegend(1);
            this.indicatorsChart.setXScrollbarEnabled(0);

            let mergedData = this.getTemplateViewModel().indicatorsDateRange().data.concat(this.getTemplateViewModel().indicatorsCompDateRange().data);

            let chart = this.indicatorsChart.setupChart(mergedData);

            if(chart.logo){

                chart.logo.disabled = true;
            }

            let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            this.indicatorsChart.applyValueAxisFormatting(valueAxis);
            valueAxis.renderer.minWidth = 50;
            valueAxis.renderer.grid.template.disabled = true;
            valueAxis.title.fontWeight = "bold";
            valueAxis.min = 0;
            valueAxis.numberFormatter.numberFormat = "#a";
            valueAxis.tooltip.disabled = true;  // Disable Y-axis tooltip

            chart.zoomOutButton.background.fillOpacity = 0.35;

            // kill pading
            chart.paddingTop = 20;
            chart.paddingBottom = 0;
            chart.paddingLeft = 0;
            chart.paddingRight = 20;

            //responsive mobile
            chart.responsive.useDefault = false
            chart.responsive.enabled = true;

            chart.responsive.rules.push({
            relevant: function(target) {
                if (target.pixelWidth <= 768) {
                return true;
                }

                return false;
            },
            state: function(target, stateId) {
                if (target instanceof am4charts.Chart) {
                var state = target.states.create(stateId);
                chart.legend.markers.template.disabled = true;
                chart.legend.labels.template.disabled = true;
                return state;
                }
                return null;
            }
            });

            let i = 0;
            for (let graphLineInfo of this.getTemplateViewModel().indicatorsDateRange().graphLinesInfo) {

                if(this.getTemplateViewModel().visitsViewsToggle() == 'visits'){

                    if(graphLineInfo.field == "viewCount" || graphLineInfo.field == "trackerBlockerViewCount" || graphLineInfo.field == "loggedInViewCount" || graphLineInfo.field == "botViewCount" || graphLineInfo.field == "suspiciousViewCount"){

                        continue;
                    }
                }
                else{

                    if(graphLineInfo.field == "visitCount" || graphLineInfo.field == "trackerBlockerVisitCount" || graphLineInfo.field == "loggedInVisitCount" || graphLineInfo.field == "botVisitCount" || graphLineInfo.field == "suspiciousVisitCount"){

                        continue;
                    }
                }

                let series = chart.series.push(new am4charts.LineSeries());
                series.dataItems.template.locations.categoryX = 0.5;
                series.dataFields.valueY = graphLineInfo.field;
                series.dataFields.customValue = graphLineInfo.field;
                series.dataFields.dateX = "dateTime";
                series.strokeOpacity = 1;
                series.strokeWidth = 3;
                series.xAxis = this.indicatorsChart.getDateAxes()[0];
                series.xAxis.renderer.labels.template.fill = am4core.color("#313050");
                series.yAxis = valueAxis;
                series.name = graphLineInfo.name;
                //series.tooltipText = "{name}: [bold]{customValue}[/]"; // Original value without abbreviation

                if(i == 0){

                    chart.plotContainer.events.on("hit", (ev) => onHit(ev, series));
                    chart.plotContainer.events.on("ready", (ev) => onReady(ev, series));
                }

                if(graphLineInfo.field == "viewCount" || graphLineInfo.field == "visitCount") {

                    series.fill = am4core.color("#313050");
                    series.stroke = am4core.color("#313050");
                }
                else if(graphLineInfo.field == "loggedInViewCount" || graphLineInfo.field == "loggedInVisitCount"){

                    series.fill = am4core.color("#5399CC");
                    series.stroke = am4core.color("#5399CC");
                }
                else if(graphLineInfo.field == "trackerBlockerViewCount" || graphLineInfo.field == "trackerBlockerVisitCount"){

                    series.fill = am4core.color("#F39237");
                    series.stroke = am4core.color("#F39237");
                }
                else if(graphLineInfo.field == "botViewCount" || graphLineInfo.field == "botVisitCount"){

                    series.fill = am4core.color("#636C99");
                    series.stroke = am4core.color("#636C99");
                    //series.hidden = true;
                }

                series.tooltipText = "{name}: [bold]{customValue}[/]";

                series.smoothing = "monotoneX";
                series.showOnInit = true;

                i++;
            }


            for (let graphLineInfo of this.getTemplateViewModel().indicatorsCompDateRange().graphLinesInfo) {

                if(this.getTemplateViewModel().visitsViewsToggle() == 'visits'){

                    if(graphLineInfo.field == "compViewCount"){

                        continue;
                    }
                }
                else{

                    if(graphLineInfo.field == "compVisitCount"){

                        continue;
                    }
                }

                let series2 = chart.series.push(new am4charts.LineSeries());
                series2.dataItems.template.locations.categoryX = 0.5;
                series2.dataFields.valueY = graphLineInfo.field;
                series2.dataFields.customValue = graphLineInfo.field;
                series2.dataFields.dateX = "compDateTime";
                series2.strokeOpacity = 1;
                series2.strokeWidth = 3;
                series2.xAxis = this.indicatorsChart.getDateAxes()[1];
                series2.xAxis.renderer.labels.template.fill = am4core.color("#D4225D");
                series2.fill = am4core.color("#D4225D");
                series2.stroke = am4core.color("#D4225D");
                series2.yAxis = valueAxis;
                series2.name = graphLineInfo.name;
                series2.xAxis.renderer.labels.template.disabled = true;
                series2.xAxis.tooltip.disabled = true;

                //responsive mobile
                series2.responsive.useDefault = false
                series2.responsive.enabled = true;

                series2.tooltipText = "{name}: [bold]{customValue}[/]";

                series2.smoothing = "monotoneX";
                series2.showOnInit = true;

            }

            chart.events.once("ready", () => {

                for (let annotation of this.getTemplateViewModel().timelineAnnotationsData()) {

                    // Use the axis of a known series to choose the correct x-axis (you have multiple).
                    const series0 = chart.series.getIndex(annotation.axis) as am4charts.LineSeries;
                    if (!series0 || !series0.xAxis) return;

                    // Cast the axis to DateAxis so TS knows about min/max, strictMinMax, etc.
                    const xAxis = series0.xAxis as am4charts.DateAxis;

                    // The moment you want to mark:
                    let eventDateTmp = annotation.date;

                    let lineOffset = 150000;

                    let offset = (eventDateTmp.getTimezoneOffset() * 60 * 1000);

                    let eventDate = new Date(eventDateTmp.getTime() - offset + lineOffset);

                    const ts = +eventDate;

                    // Create the range and cast it to DateAxisDataItem so .value/.date are valid
                    const range = xAxis.axisRanges.create() as am4charts.DateAxisDataItem;

                    // Either set value (timestamp) or date (Date) — both are valid on DateAxisDataItem
                    range.value = ts;              // or: range.date = eventDate;

                    // Style the line
                    range.grid.stroke = am4core.color("#FF0000");
                    range.grid.strokeWidth = 2;
                    range.grid.strokeOpacity = 1;
                    range.grid.strokeDasharray = "4,4";
                    range.grid.zIndex = 1000;

                    // Label / note
                    //range.label.text = "Annotation";
                    range.label.rotation = -90;
                    range.label.horizontalCenter = "right";
                    range.label.verticalCenter = "bottom";
                    range.label.dy = -150;                     // tweak up/down if needed

                    range.label.inside = true;
                    range.label.fill = am4core.color("#D41C5C");
                    range.label.padding(0, 6, 0, 6);
                }
            });

            this.getTemplateViewModel().indicatorsChartObj(chart);

        } else {

            let chartData = this.getTemplateViewModel().indicatorsDateRange().data;
            let visitsViewToggle = this.getTemplateViewModel().visitsViewsToggle();

            this.indicatorsChart.setNbOfXAxes(1)
            this.indicatorsChart.setDateFormat("fiveMinutes");
            this.indicatorsChart.setDateFields("dateTime");
            this.indicatorsChart.setCursorEnabled(1);
            this.indicatorsChart.setLabelMaxWidth(80);
            this.indicatorsChart.setAutoRotateLabels(1);
            this.indicatorsChart.setClickableLegend(1);
            this.indicatorsChart.setXScrollbarEnabled(0);

            let chart = this.indicatorsChart.setupChart(chartData);

            let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            this.indicatorsChart.applyValueAxisFormatting(valueAxis);
            valueAxis.renderer.minWidth = 50;
            valueAxis.renderer.grid.template.disabled = true;

            valueAxis.title.fontWeight = "bold";
            valueAxis.min = 0;

            let count = 0;
            for (let graphLineInfo of this.getTemplateViewModel().indicatorsDateRange().graphLinesInfo) {

                let series = chart.series.push(new am4charts.LineSeries());
                let color = liveDashboard_template.getPaletteColor(count);

                series.dataItems.template.locations.categoryX = 0.5;
                series.dataFields.valueY = visitsViewToggle == 'visits' ? graphLineInfo.valueVisitCount : graphLineInfo.valueViewCount;
                series.dataFields.customValue = visitsViewToggle == 'visits' ? graphLineInfo.valueVisitCount : graphLineInfo.valueViewCount;
                series.dataFields.dateX = graphLineInfo.field;
                series.strokeOpacity = 1;
                series.strokeWidth = 2;
                series.fill = am4core.color(color);
                series.stroke = am4core.color(color);
                series.yAxis = valueAxis;
                series.name = visitsViewToggle == 'visits' ? graphLineInfo.nameVisitCount : graphLineInfo.nameViewCount;

                series.tooltipText = "{name}: [bold]{customValue}[/]";
                series.smoothing = "monotoneX";
                series.showOnInit = true;

                if (count == 0) {

                    chart.plotContainer.events.on("hit", (ev) => onHit(ev, series));
                    chart.plotContainer.events.on("ready", (ev) => onReady(ev, series));
                }

                count++;
            }

            chart.events.once("ready", () => {

                for (let annotation of this.getTemplateViewModel().timelineAnnotationsData()) {

                    // Use the axis of a known series to choose the correct x-axis (you have multiple).
                    const series0 = chart.series.getIndex(annotation.axis) as am4charts.LineSeries;
                    if (!series0 || !series0.xAxis) return;

                    // Cast the axis to DateAxis so TS knows about min/max, strictMinMax, etc.
                    const xAxis = series0.xAxis as am4charts.DateAxis;

                    // The moment you want to mark:
                    let eventDateTmp = annotation.date;

                    let lineOffset = 150000;

                    let offset = (eventDateTmp.getTimezoneOffset() * 60 * 1000);

                    let eventDate = new Date(eventDateTmp.getTime() - offset + lineOffset);

                    const ts = +eventDate;

                    // Create the range and cast it to DateAxisDataItem so .value/.date are valid
                    const range = xAxis.axisRanges.create() as am4charts.DateAxisDataItem;

                    // Either set value (timestamp) or date (Date) — both are valid on DateAxisDataItem
                    range.value = ts;              // or: range.date = eventDate;

                    // Style the line
                    range.grid.stroke = am4core.color("#FF0000");
                    range.grid.strokeWidth = 2;
                    range.grid.strokeOpacity = 1;
                    range.grid.strokeDasharray = "4,4";
                    range.grid.zIndex = 1000;

                    // Label / note
                    //range.label.text = "Annotation";
                    range.label.rotation = -90;
                    range.label.horizontalCenter = "right";
                    range.label.verticalCenter = "bottom";
                    range.label.dy = -150;                     // tweak up/down if needed

                    range.label.inside = true;
                    range.label.fill = am4core.color("#D41C5C");
                    range.label.padding(0, 6, 0, 6);
                }
            });

            if(chart.logo){

                chart.logo.disabled = true;
            }

            this.getTemplateViewModel().indicatorsChartObj(chart);
        }




    }

    public setPingDiffIndicatorsData(indicatorsData) {

        for(let i = 0; i < indicatorsData.pingDiff.dateRange.data.length; i++) {

            indicatorsData.pingDiff.dateRange.data[i].dateTime = new Date(indicatorsData.pingDiff.dateRange.data[i].dateTime);
        }

        this.getTemplateViewModel().pingDiffIndicatorsDateRange(indicatorsData.pingDiff.dateRange);
    }

    public setPingLoadTimeIndicatorsData(indicatorsData) {

        for(let i = 0; i < indicatorsData.pingAvgLoad.dateRange.data.length; i++) {

            indicatorsData.pingAvgLoad.dateRange.data[i].dateTime = new Date(indicatorsData.pingAvgLoad.dateRange.data[i].dateTime);
        }

        this.getTemplateViewModel().pingAvgLoadIndicatorsDateRange(indicatorsData.pingAvgLoad.dateRange);
    }

    public setIndicatorsData(indicatorsData) {

        for(let i = 0; i < indicatorsData.dateRange.data.length; i++){

            indicatorsData.dateRange.data[i].dateTime = new Date(indicatorsData.dateRange.data[i].dateTime);
        }
        this.getTemplateViewModel().indicatorsDateRange(indicatorsData.dateRange);
        this.getTemplateViewModel().indicatorsDateRangeDataLength(indicatorsData.dateRange.data.length);

        if(indicatorsData.compDateRange) {

            for(let i = 0; i < indicatorsData.compDateRange.data.length; i++){

                indicatorsData.compDateRange.data[i].compDateTime = new Date(indicatorsData.compDateRange.data[i].compDateTime);
            }
            this.getTemplateViewModel().indicatorsCompDateRange(indicatorsData.compDateRange);
            this.getTemplateViewModel().indicatorsCompDateRangeDataLength(indicatorsData.compDateRange.data.length);
        }
    }

    public setTotalsData(totalsData) {

        this.getTemplateViewModel().totalsData(totalsData);
    }

    public setTopArticlesData(topArticlesData) {

        this.getTemplateViewModel().topArticlesData(topArticlesData);
        this.getTemplateViewModel().showTableDimensions(false);
    }

    public setTableDimensionsData(tableDimensionsData) {

        this.getTemplateViewModel().tableDimensionsData(tableDimensionsData);
        this.getTemplateViewModel().showTableDimensions(true);
    }

    public updateComparisonSwitch() {

        this.getTemplateViewModel().comparisonSwitch(this.comparisonFilter.getSelectedOption());
    }

    public updateVisitsViewsToggle() {

        this.getTemplateViewModel().visitsViewsToggle(this.metricFilter.getSelectedOption());
    }

    public setIndicatorsBreakdownData(indicatorsBreakdownData) {

        this.getTemplateViewModel().indicatorsBreakdownData(indicatorsBreakdownData);
        //this.getTemplateViewModel().indicatorsBreakdownLength(Object.keys(indicatorsBreakdownData.indicatorsBreakdown).length);
        this.updateBreakdownDonutCharts();
    }

    public updateBreakdownDonutCharts() {

        if(this.getTemplateViewModel().visitsViewsToggle() == 'visits'){

            this.androidViewsDonutChart.setCategoryName("categoryNameVisits");
            this.androidViewsDonutChart.setValueName("visitCount")
            this.androidViewsDonutChart.drawChart(this.getTemplateViewModel().indicatorsBreakdownData().androidViewsBreakdown);

            this.usViewsDonutChart.setCategoryName("categoryNameVisits");
            this.usViewsDonutChart.setValueName("visitCount")
            this.usViewsDonutChart.drawChart(this.getTemplateViewModel().indicatorsBreakdownData().usViewsBreakdown);
        }
        else{

            this.androidViewsDonutChart.setCategoryName("categoryNameViews");
            this.androidViewsDonutChart.setValueName("viewCount")
            this.androidViewsDonutChart.drawChart(this.getTemplateViewModel().indicatorsBreakdownData().androidViewsBreakdown);

            this.usViewsDonutChart.setCategoryName("categoryNameViews");
            this.usViewsDonutChart.setValueName("viewCount")
            this.usViewsDonutChart.drawChart(this.getTemplateViewModel().indicatorsBreakdownData().usViewsBreakdown);
        }
    }

    public setSegmentsData(segmentsData) {

        this.getTemplateViewModel().segmentsData(segmentsData);
    }

    public setPageOffset(page){

        this.getTemplateViewModel().pageOffset(page);
    }

    public setDefaultDevices(){

        // Select by default Mobile, Desktop, Tablet
        const filter = this.getTemplateViewModel().dynamicFilters().find(f => f.filterId == 'device-internalDimension').filter;

        let defaultDevices = ['Mobile', 'Desktop', 'Tablet'];
        let filterItems = filter.getItems().filter(i => i && defaultDevices.includes(i.name));
        let filterItemIds = filterItems.map(i => i.id);

        if(filter.getTemplateName() === 'multiSelector-template'){

            filter.setSelectedItems(filterItems);
            filter.setTags(filterItemIds, filter.getItems());
        }
    }

    static stringToColour(str){

        let hash = 0;
        for (let i = 0; i < str.length; i++){

            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }

        let colour = '#';
        for (let i = 0; i < 3; i++){

            let value = (hash >> (i * 8)) & 0xFF;
            colour += ('00' + value.toString(16)).substr(-2);
        }

        return colour;
    }

    private formatSnapshotDate(date) {

        const pad = (n) => n.toString().padStart(2, '0');
        return `${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
    }

    public setViewModelFromRequest(params : Array<any>): void{

        if(typeof params['selectedBrand'] !== 'undefined'){

            this.brandFilter.getTemplateViewModel().selectedOption(params['selectedBrand']);
        }

        if(typeof params['selectedBrandText'] !== 'undefined'){
            this.brandFilter.getTemplateViewModel().selectedOptionText(params['selectedBrandText']);
        }

        if(typeof params['comparisonSwitch'] !== 'undefined'){

            this.comparisonFilter.setSelectedOption(params['comparisonSwitch'])
        }

        if(typeof params['comparisonSwitchText'] !== 'undefined'){

            this.comparisonFilter.setSelectedOptionText(params['comparisonSwitchText'])
        }

        if(typeof params['visitsViewsToggle'] !== 'undefined'){

            this.metricFilter.setSelectedOption(params['visitsViewsToggle'])
        }

        if(typeof params['visitsViewsToggleText'] !== 'undefined'){

            this.metricFilter.setSelectedOptionText(params['visitsViewsToggleText'])
        }

        if(typeof params['selectedInterval'] !== 'undefined'){

            this.intervalFilter.setSelectedOption(params['selectedInterval'])
        }

        if(typeof params['selectedIntervalText'] !== 'undefined'){

            this.intervalFilter.setSelectedOptionText(params['selectedIntervalText'])
        }

        if(typeof params['selectedSegment'] !== 'undefined'){

            this.segmentsFilter.getTemplateViewModel().selectedOption(params['selectedSegment']);
        }

        if(typeof params['isBotMode'] !== 'undefined'){

            this.getTemplateViewModel().isBotMode(params['isBotMode']);
        }

        if(typeof params['deltaMode'] !== 'undefined'){

            const sanitized = this.sanitizeDeltaMode(params['deltaMode']);
            this.deltaFilter.setSelectedOption(sanitized);
            this.deltaFilter.setSelectedOptionText(this.getDeltaOptionName(sanitized));
            this.getTemplateViewModel().deltaMode(sanitized);
        }

        if(typeof params['dimensionGroupSwitch'] !== 'undefined'){

            this.getTemplateViewModel().dimensionGroupSwitch(params['dimensionGroupSwitch']);
        }

        if(typeof params['selectedDynamicFilters'] !== 'undefined' && Array.isArray(params['selectedDynamicFilters'])){

            let dynamicFilters = this.getTemplateViewModel().dynamicFilters();

            params['selectedDynamicFilters'].forEach(selectedDynamicFilter => {

                Object.values(selectedDynamicFilter).forEach(category => {

                    if (typeof category === 'object' && category !== null) {

                        Object.values(category).forEach(categoryFilter => {

                            let dynamicFilter = dynamicFilters.find(obj => obj.filter.idElement === categoryFilter.id);

                            if(dynamicFilter){

                                let filter = dynamicFilter.filter;

                                if(categoryFilter.type === 'multiSelect'){

                                    if(categoryFilter.items.length > 0 || categoryFilter.keyword != ''){

                                        let filterIds = categoryFilter.items.map(obj => obj.id);
                                        this.presetFilter.setMultiSelectorPresetFilters(filter, filterIds, categoryFilter.keyword);
                                    }
                                }
                                else if(categoryFilter.type === 'autoCompleteMultiSelect'){

                                    if(categoryFilter.items.length > 0 || categoryFilter.keyword != ''){

                                        let filterIds = categoryFilter.items.map(obj => obj.id);
                                        let filterNames = categoryFilter.items.map(obj => obj.name);
                                        this.presetFilter.setMultipleAutocompletePresetFilter(filter, filterIds, filterNames, categoryFilter.keyword);
                                    }
                                }
                                else if(categoryFilter.type === 'searchField'){

                                    if(categoryFilter.keyword != ''){

                                        filter.getTemplateViewModel().filterKeyword(categoryFilter.keyword);
                                    }

                                }
                            }
                        });
                    }
                });

            });

            this.getTemplateViewModel().dynamicFilters(dynamicFilters);
        }

        this.presetFilter.setDates(this.dateRangeFilter, params['dateFilterType'], params['startDate'], params['endDate'], params['startDateRange'], params['endDateRange']);
        this.presetFilter.setDates(this.compRangeFilter, params['compDateFilterType'], params['compStartDate'], params['compEndDate'], params['compStartDateRange'], params['compEndDateRange']);

        this.updateComparisonSwitch();
        this.updateVisitsViewsToggle();
    }

    static getPaletteColor(number) {

        switch(number) {
            case 0:
                return "#8d82d2";
            case 1:
                return "#5fc6f2";
            case 2:
                return "#78e9cc"; // Bold Green
            case 3:
                return "#ffd380"; // Vivid Red
            case 4:
                return "#312D69"; // Purple
            case 5:
                return "#D8366D"; // Dark Gray
            case 6:
                return "#1CA71C"; // Bright Yellow
            case 7:
                return "#00C49A"; // Teal
            case 8:
                return "#FF5733"; // Orange-Red
            case 9:
                return "#6A329F"; // Deep Purple
            default:
                return "#000000";  // Default case if number doesn't match any case
        }
    }

    public setTimelineAnnotationsData(timelineAnnotationsData, axis) {

        let timelineAnnotations = this.getTemplateViewModel().timelineAnnotationsData();

        for(let i = 0; i < timelineAnnotationsData.length; i++) {

            timelineAnnotationsData[i].dateOrig = timelineAnnotationsData[i].date;
            timelineAnnotationsData[i].date = new Date(timelineAnnotationsData[i].date);
            timelineAnnotationsData[i].axis = axis;

            timelineAnnotations.push(timelineAnnotationsData[i]);
        }

        // sort based on the date
        timelineAnnotations.sort((a, b) => a.date.getTime() - b.date.getTime());

        this.getTemplateViewModel().timelineAnnotationsData(timelineAnnotations);

        //remove duplicates
        timelineAnnotations = Array.from(
            new Map(timelineAnnotations.map(u => [u.id, u])).values()
        );

        // format for tooltip
        let formattedAnnotationTooltip = '<ul>';
        for(let i = 0; i < timelineAnnotations.length; i++) {

            let formattedDate = timelineAnnotations[i].dateOrig.substring(0, 13)+'H';

            formattedAnnotationTooltip += '<li class="col"><strong>' + formattedDate + '</strong><p>'+ timelineAnnotations[i].annotation +'</p></li>';
        }
        formattedAnnotationTooltip += '</ul>';


        this.annotationTooltip.setContent(formattedAnnotationTooltip);
    }

    public clearTimelineAnnotatonData(){

        this.getTemplateViewModel().timelineAnnotationsData([]);
    }

    public getDimensionNiceName(){

        const dimensionGroupSwitch = this.getTemplateViewModel().dimensionGroupSwitch();

        switch(dimensionGroupSwitch){

            case 'device': return 'Device';
            case 'deviceModel': return 'Device Model';
            case 'os': return 'Operating System';
            case 'browser': return 'Browser';
            case 'browserVersion': return 'Browser Version';
            case 'adBlockerStatus': return 'Ad Block';
            case 'ip': return 'IP Address';
            case 'userAgent': return 'User Agent';
            case 'geo': return 'Geo';
            case 'city': return 'City';
            case 'permalink': return 'Permalink';
            case 'ampStatus': return 'AMP';
            case 'referrer': return 'Referrer';
            case 'trafficChannel': return 'Traffic Channel';
            case 'hostname': return 'Hostname';
            case 'loginStatus': return 'Login Status';
            case 'plan': return 'Plan';
            case 'identitySource': return 'Identity Source';
            case 'robotName': return 'Robot Name';
            case 'robotCategory': return 'Robot Category';

            default: return dimensionGroupSwitch;
        }
    }

    private formatMinuteSeconds(value){

        if (value === null || typeof value === 'undefined' || value === '') {

            return '-';
        }

        if (isNaN(parseInt(value))) {

            return value;
        }else {

            return Math.floor(parseInt(value) / 60) + ":" + (parseInt(value) % 60).toLocaleString('en-US', {
                minimumIntegerDigits: 2,
                useGrouping: false
            });
        }
    }

    private formatNullablePercentage(value){

        if (value === null || typeof value === 'undefined' || value === '' || isNaN(Number(value))) {

            return '-';
        }

        return Number(value).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0}) + '%';
    }

    private formatCpm(value){

        if (value === null || typeof value === 'undefined' || value === '' || isNaN(Number(value))) {

            return '-';
        }

        return Number(value).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    }

    private formatDayCpm(value){

        if (value === null || typeof value === 'undefined' || value === '' || isNaN(Number(value))) {

            return '';
        }

        return this.formatCpm(value) + ' today';
    }

    private formatInteractionRatio(value: any){

        if (value === null || typeof value === 'undefined' || value === '' || isNaN(Number(value))) {

            return '-';
        }

        return Number(value).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%';
    }

    private hasTableDelta(value){

        const deltaMode = this.getTemplateViewModel().deltaMode();

        if(deltaMode === 'off'){

            return false;
        }

        if(this.getTemplateViewModel().showTableDimensions() && deltaMode === 'segmentSystemAverage'){

            return false;
        }

        return value !== null && typeof value !== 'undefined' && value !== '' && !isNaN(Number(value));
    }

    private formatTableDelta(value){

        if (!this.hasTableDelta(value)) {

            return '';
        }

        const roundedValue = Math.round(Number(value));
        const normalizedRoundedValue = roundedValue === 0 ? 0 : roundedValue;

        return (normalizedRoundedValue > 0 ? '+' : '') + normalizedRoundedValue.toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0}) + '%';
    }

    private sanitizeDeltaMode(value){

        const availableDeltaModes = this.getTemplateViewModel().deltaToggleButtonException()
            ? ['segmentSystemAverage', 'filterAverage', 'off']
            : ['filterAverage', 'off'];

        if(availableDeltaModes.includes(value)){

            return value;
        }

        return this.getTemplateViewModel().deltaToggleButtonException() ? 'segmentSystemAverage' : 'filterAverage';
    }


}



// WEBPACK FOOTER //
// ./js/components/templates/liveDashboard_template.ts